//Globalní proměnné
// na kraztší zjištění stránky a jazyka

window.shoptetPage = dataLayer[0].shoptet.pageType;
window.shoptetLang = dataLayer[0].shoptet.language;

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('img').forEach(img => {
        img.addEventListener('contextmenu', (e) => {
            e.preventDefault();  // Zabrání otevření kontextového menu
        });
    });
});

// přesunování elementů
export function moveElement(elementSelector, targetSelectors) {
	const element = document.querySelector(elementSelector);
	const footer = document.querySelector('footer');

	if (!element) {
		console.error(`Prvek ${elementSelector} nebyl nalezen`);
		return;
	}

	let moved = false;

	for (const targetSelector of targetSelectors) {
		const target = document.querySelector(targetSelector);
		if (target) {
			target.insertAdjacentElement('afterend', element);
			moved = true;
			break;
		}
	}

	if (!moved && footer) {
		footer.insertAdjacentElement('beforebegin', element);
	}
}


//On funkce, na kliknutí a zavolání funkce
export function on(eventType, selector, callback) {
	document.addEventListener(eventType, function (e) {
		let targetElement = e.target;
		while (targetElement && targetElement !== document) {
			if (targetElement.matches(selector)) {
				e.preventDefault();
				callback.call(targetElement, e);
				break;
			}
			targetElement = targetElement.parentElement;
		}
	});
}

//z hrefu na další sekci
function scrollToNextSectionOrHref(e) {
	if (this.getAttribute('href') === '#next') {
		e.preventDefault();
		scrollToNextSection.call(this);
	}
}



// window.addEventListener('load', () => document.body.classList.add('hideSpinner'))
const debounce = (func, delay) => {
	let debounceTimer
	return function () {
		const context = this
		const args = arguments
		clearTimeout(debounceTimer)
		debounceTimer = setTimeout(() => func.apply(context, args), delay)
	}
}

const currentPath = window.location.pathname
const links = document.querySelectorAll('.menu-level-1 li a')
links.forEach((link) => {
	const linkPath = new URL(link.href).pathname
	if (linkPath === currentPath) {
		link.classList.add('active')
	}
})

const links2 = document.querySelectorAll('.top-navigation-bar-menu li a')
links2.forEach((link) => {
	const linkPath = new URL(link.href).pathname
	if (linkPath === currentPath) {
		link.classList.add('active')
	}
})


window.productsSlickSettings = {
	slidesToShow: 5,
	infinite: false,
	responsive: [
		{
			breakpoint: 1350,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 830,
			settings: {
				slidesToShow: 2,
			},
		},
	],
}




function fixedHeader() {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop
	// const header2 = document.querySelector('.user-action-cart')
	// const login = document.querySelector('.user-action-login')
	const header = document.querySelector('#header')

	if (scrollTop > 45) {
		if (header) {
			header.classList.add('sticky')
		}
		// if (header2) {
		// 	header2.classList.add('sticky')
		// }
		// if (login) {
		// }
		// login.classList.add('sticky')

		// header.classList.remove('scroll-up')
		// header.classList.add('scroll-down')
	} else {
		// header.classList.remove('scroll-down')
		// header.classList.add('scroll-up')

		if (header) {
			header.classList.remove('sticky')
		}
		// if (header2) {
		// 	header2.classList.remove('sticky')
		// }
		// if (login) {
		// }
		// login.classList.remove('sticky')
	}
}

document.addEventListener('DOMContentLoaded', fixedHeader)
window.addEventListener('scroll', fixedHeader)

const moveRegistrationBannerLogin = async () => {
	if (dataLayer[0].shoptet.customer.registered === false) {
		let registrationBannerLogin = document.querySelector('.registration-banner-login')
		if (!registrationBannerLogin) {
			const storedBanner = sessionStorage.getItem('registrationBannerLogin')
			if (storedBanner) {
				const parser = new DOMParser()
				const doc = parser.parseFromString(storedBanner, 'text/html')
				registrationBannerLogin = doc.body.firstChild
			} else {
				const response = await fetch('/')
				const text = await response.text()
				const parser = new DOMParser()
				const htmlDocument = parser.parseFromString(text, 'text/html')
				registrationBannerLogin = htmlDocument.querySelector('.registration-banner-login')
				if (registrationBannerLogin) {
					sessionStorage.setItem('registrationBannerLogin', registrationBannerLogin.outerHTML)
				}
			}
		} else {
			sessionStorage.setItem('registrationBannerLogin', registrationBannerLogin.outerHTML)
		}

		// const userActionLogin = document.querySelector('.user-action-login')
		// const h2 = userActionLogin.querySelector('.popup-widget-inner h2')
		// const popUpLoginText = popUpLogin.find((item) => item.language === shoptetLang)
		// if (popUpLoginText) {
		// 	h2.innerHTML = popUpLoginText.text
		// }
		// const socialLogin = userActionLogin.querySelector('.popup-widget-inner .social-login-buttons-divider span');
		// const otherLogin = otherLogins.find(item => item.language === shoptetLang);
		// if (otherLogin) {
		// 	socialLogin.innerHTML = otherLogin.text;
		// }
		// const perex = userActionLogin.querySelector('.popup-widget-inner p')
		// if (!perex) {
		// 	const loginPerex = document.createElement('p')
		// 	const loginPerexText = loginBeneText.find((item) => item.language === shoptetLang)
		// 	if (loginPerexText) {
		// 		loginPerex.innerHTML = loginPerexText.text
		// 	}
		// 	h2.insertAdjacentElement('afterend', loginPerex)
		// 	if (registrationBannerLogin && userActionLogin) {
		// 		userActionLogin.appendChild(registrationBannerLogin)
		// 	}
		// }

		// const bgClose = userActionLogin.querySelector('.bg-close')
		// if (!bgClose) {
		// 	const bgClose2 = document.createElement('div')
		// 	bgClose2.classList.add('bg-close')
		// 	userActionLogin.appendChild(bgClose2)
		// 	bgClose2.addEventListener('click', () => {
		// 		document.body.classList.remove('login-window-visible')
		// 		document.body.classList.remove('user-action-visible')
		// 	})
		// }

		// const close = userActionLogin.querySelector('.close')
		// if (!close) {
		// 	const close2 = document.createElement('div')
		// 	close2.classList.add('close')
		// 	close2.innerHTML = '<div></div><div></div>'
		// 	userActionLogin.appendChild(close2)
		// 	close2.addEventListener('click', (event) => {
		// 		if (event.target.closest('.close')) {
		// 			document.body.classList.remove('login-window-visible')
		// 			document.body.classList.remove('user-action-visible')
		// 		}
		// 	})
		// }
	}
}

moveRegistrationBannerLogin()
document.addEventListener('ShoptetDOMPageContentLoaded', moveRegistrationBannerLogin)
document.addEventListener('ShoptetDOMContentLoaded', moveRegistrationBannerLogin)


const handleHeader = async () => {
	// const navigation = document.querySelector('#navigation');
	// if (window.innerWidth <= 767) {
	// 	const headerTop = document.querySelector('.header-top')
	// 	if (search && headerTop) {
	// 		headerTop.insertAdjacentElement('afterend', search)
	// 	}
	// }

	// const topContacts = document.querySelector('.top-navigation-contacts')
	// if (topContacts) {
	// 	const address2 = topContacts.querySelector('address')
	// 	if (!address2) {
	// 		if (headlineAddress) {
	// 			const address = document.createElement('address')
	// 			address.innerHTML = headlineAddress
	// 			topContacts.appendChild(address)
	// 		}
	// 	}
	// }
	const searchBtn = document.querySelector('#formSearchForm button')
	if (searchBtn) {
		searchBtn.textContent = ''
	}

	const headerTopW = document.querySelector('.header-top')
	const search = document.querySelector('.header-top .search')

	const navigation = document.querySelector('#navigation')
	const menuHelper = document.querySelector('.menu-helper')
	if (menuHelper && navigation) navigation.appendChild(menuHelper)
	const navigationButtons = document.querySelector('.navigation-buttons');
	const existingLink = navigationButtons.querySelector('.contacts');
	if (!existingLink) {
		const newLink = document.createElement('a');
		newLink.classList.add('contacts');
		newLink.href = "/kontakty";
		newLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" xmlns:v="https://vecta.io/nano"><g clip-path="url(#B)"><mask id="A" fill="#fff"><path d="M2.85 8.99h3.88a1.96 1.96 0 0 1-.355.835c-.183.25-.413.448-.69.595s-.575.22-.895.22-.618-.073-.895-.22-.507-.345-.69-.595a1.96 1.96 0 0 1-.355-.835zm2.54-5.26h13.06l2.34 4.44H3.07l2.32-4.44zm13.78 6.94c-.26.013-.515-.025-.765-.115a1.98 1.98 0 0 1-.655-.385 2.07 2.07 0 0 1-.64-1.18h3.92c-.047.307-.157.585-.33.835s-.393.45-.66.6-.557.232-.87.245zm-4.76 0c-.26.013-.515-.025-.765-.115a1.98 1.98 0 0 1-.655-.385 2.07 2.07 0 0 1-.64-1.18h3.92c-.047.307-.157.585-.33.835s-.393.45-.66.6-.557.232-.87.245zm-4.86-.02c-.32-.007-.618-.083-.895-.23s-.507-.345-.69-.595a1.96 1.96 0 0 1-.355-.835h3.88a1.93 1.93 0 0 1-.36.835 2.06 2.06 0 0 1-.695.595c-.277.147-.572.223-.885.23zm4.96 9.26H4.35v-8.5a3.32 3.32 0 0 0 .44.04 2.75 2.75 0 0 0 1.39-.39c.407-.24.737-.57.99-.99.247.407.577.733.99.98.427.26.89.393 1.39.4a2.77 2.77 0 0 0 1.37-.38 2.9 2.9 0 0 0 .99-.96c.14.24.32.46.54.66.26.233.55.412.87.535a2.73 2.73 0 0 0 .99.185h.14c.467-.02.903-.153 1.31-.4.387-.24.697-.553.93-.94.173.273.347.48.52.62.26.233.55.412.87.535a2.73 2.73 0 0 0 .99.185h.14a2.74 2.74 0 0 0 1.36-.44c.393-.253.707-.592.94-1.015s.347-.878.34-1.365c.027-.12.013-.213-.04-.28l-2.74-5.24a.4.4 0 0 0-.36-.22H5.15a.42.42 0 0 0-.22.06c-.067.04-.113.093-.14.16L2.05 8.4c-.007.007-.013.01-.02.01v.02l-.01.03c-.007.02-.01.037-.01.05v.08c-.007.54.13 1.04.41 1.5.273.447.643.793 1.11 1.04v9.18c0 .107.04.2.12.28s.173.12.28.12h10.58a.38.38 0 0 0 .285-.12.44.44 0 0 0 .125-.285c.007-.11-.03-.203-.11-.28s-.18-.115-.3-.115zm6.68-3.16c0 .353-.16.827-.48 1.42-.267.487-.627 1.033-1.08 1.64l-1.12 1.38c-.653-.753-1.22-1.493-1.7-2.22-.653-.987-.98-1.733-.98-2.24 0-.487.12-.935.36-1.345a2.68 2.68 0 0 1 .975-.975c.41-.24.858-.36 1.345-.36a2.66 2.66 0 0 1 1.025.2 2.65 2.65 0 0 1 .87.585c.257.257.452.55.585.88a2.74 2.74 0 0 1 .2 1.035zm-.22-2.48c-.327-.327-.703-.578-1.13-.755s-.87-.265-1.33-.265a3.39 3.39 0 0 0-1.76.48c-.527.307-.947.723-1.26 1.25-.32.547-.48 1.137-.48 1.77 0 .527.243 1.213.73 2.06.36.627.837 1.317 1.43 2.07l1 1.19.02.02a.42.42 0 0 0 .3.14.36.36 0 0 0 .3-.14l.04-.04 1.03-1.22c.587-.74 1.057-1.42 1.41-2.04.48-.833.72-1.513.72-2.04 0-.473-.088-.923-.265-1.35a3.45 3.45 0 0 0-.755-1.13zm-2.46 3.06a.56.56 0 0 1-.58-.58.56.56 0 0 1 .58-.58.56.56 0 0 1 .58.58.56.56 0 0 1-.58.58zm0-1.98a1.38 1.38 0 0 0-.695.185c-.217.123-.388.293-.515.51s-.19.45-.19.7.063.483.19.7.297.388.51.515.447.19.7.19a1.4 1.4 0 0 0 .705-.185 1.34 1.34 0 0 0 .51-.51c.123-.217.183-.452.18-.705a1.41 1.41 0 0 0-.195-.705c-.127-.217-.297-.387-.51-.51s-.443-.185-.69-.185zM7.13 19.91v-6.14h3.26v6.14c0 .113.038.208.115.285s.172.115.285.115.208-.038.285-.115.115-.172.115-.285v-6.54c0-.113-.038-.208-.115-.285s-.172-.115-.285-.115H6.73c-.113 0-.208.038-.285.115s-.115.172-.115.285v6.54c0 .113.038.208.115.285s.172.115.285.115.208-.038.285-.115.115-.172.115-.285z"/></mask><path d="M6.73 13.37h-1v-1h1v1zm4.06 0v-1h1v1h-1zm-3.64 5.54h3.2v2h-3.2v-2zm-1.42 1.4v-.022-.02-.023-.023-.022-.024-.021-.022-.024-.025-.026-.021-.021-.022-.023-.024-.024-.025-.025-.026-.027-.027-.028-.029-.029-.03-.02-.021-.021-.021-.021-.022-.022-.022-.022-.023-.023-.023-.023-.024-.024-.024-.024-.025-.025-.025-.025-.026-.026-.026-.026-.026-.027-.027-.027-.027-.027-.028-.028-.028-.028-.028-.029-.029-.029-.029-.029-.03-.03-.03-.03-.03-.03-.031-.031-.031-.031-.031-.031-.032-.032-.032-.032-.032-.032-.032-.032-.032-.033-.033-.033-.033-.033-.033-.033-.033-.034-.034-.034-.034-.034-.034-.034-.034-.034-.034-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.036-.036-.035-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.036-.035-.036-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.035-.034-.034-.034-.034-.034-.034-.034-.034-.034-.034-.034-.033-.033-.033-.033-.033-.033-.033-.033-.033-.032-.032-.032-.032-.032-.032-.032-.031-.031-.031-.031-.031-.031-.03-.03-.03-.03-.03-.03-.029-.029-.029-.029-.029-.029-.028-.028-.028-.028-.028-.027-.027-.027-.027h2v.027.027.027.027.028.028.028.028.028.029.029.029.029.029.029.03.03.03.03.03.03.031.031.031.031.031.031.032.032.032.032.032.032.032.033.033.033.033.033.033.033.033.033.034.034.034.034.034.034.034.034.034.034.034.035.035.035.035.035.035.035.035.035.035.035.035.035.035.035.035.036.035.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.036.035.036.036.035.035.035.035.035.035.035.035.035.035.035.035.035.035.035.035.035.034.034.034.034.034.034.034.034.034.034.033.033.033.033.033.033.033.033.032.032.032.032.032.032.032.032.032.031.031.031.031.031.031.03.03.03.03.03.03.029.029.029.029.029.028.028.028.028.028.027.027.027.027.027.026.026.026.026.026.025.025.025.025.024.024.024.024.023.023.023.023.022.022.022.022.021.021.021.021.02.02.03.029.028.028.027.026.026.025.024.024.023.022.022.021.027.025.024.023.021.024.022.024.02.022.021l-2 .005zm1-7.94h4.06v2H6.73v-2zm5.06 1v6.94h-2v-6.94h2zM2.85 8.99l-1.97.343L.472 6.99H2.85v2zm3.88 0v-2h2.378L8.7 9.333 6.73 8.99zM5.39 3.73l-1.773-.926.561-1.074H5.39v2zm13.06 0v-2h1.207l.563 1.068-1.769.932zm2.34 4.44l1.769-.932 1.546 2.933H20.79v-2zm-17.72 0v2H-.232l1.529-2.926 1.773.926zm16.1 2.5l-.102-1.997h.009.009l.085 1.998zm-1.42-.5l-1.332 1.492-.02-.018-.02-.018 1.372-1.456zm-.64-1.18l-1.97.343-.407-2.343h2.378v2zm3.92 0v-2h2.327l-.35 2.301-1.977-.301zm-6.62 1.68l-.102-1.997h.009.009l.085 1.998zm-1.42-.5l-1.332 1.492-.02-.018-.02-.018 1.372-1.456zm-.64-1.18l-1.97.343-.407-2.343h2.378v2zm3.92 0v-2h2.327l-.35 2.301-1.977-.301zm-6.72 1.66l.043 1.999H9.55h-.042l.042-1.999zM7.61 8.99l-1.97.343-.407-2.343H7.61v2zm3.88 0v-2h2.378l-.407 2.343-1.97-.343zM4.35 19.91v2h-2v-2h2zm0-8.5h-2V9.104l2.283.326-.283 1.98zm.44.04l.027 2h-.013-.013v-2zm1.39-.39L5.159 9.34l.005-.003L6.18 11.06zm.99-.99L5.457 9.037l1.708-2.831L8.88 9.033 7.17 10.07zm.99.98l1.025-1.717.008.005.008.005L8.16 11.05zm1.39.4l.027 2H9.55h-.027l.027-2zm1.37-.38l1.017 1.722-.008.005-.008.005-1.001-1.732zm.99-.96l-1.69-1.07 1.76-2.779 1.657 2.841-1.728 1.008zm.54.66l-1.336 1.489-.01-.009 1.345-1.48zm2 .72l.086 1.998-.043.002h-.043v-2zm1.31-.4l1.055 1.699-.009.005-.009.005-1.037-1.71zm.93-.94l-1.712-1.033 1.67-2.768 1.731 2.73-1.689 1.071zm.52.62l1.257-1.556.04.033.039.035-1.336 1.489zm2 .72l.108 1.997-.054.003h-.054v-2zm1.36-.44l-1.084-1.681h.001l1.083 1.681zm1.28-2.38l-2 .027-.003-.233.051-.228 1.952.434zm-.04-.28l-1.562 1.249-.121-.151-.09-.172 1.772-.927zm-2.74-5.24l1.722-1.017.026.045.024.046-1.772.927zm-14.28 0l1.857.743-.037.093-.047.089L4.79 3.15zM2.05 8.4l1.773.925-.142.272-.217.217L2.05 8.4zm-.02.01h-2v-2h2v2zm0 .02h2v.325l-.103.308L2.03 8.43zm-.01.03L.123 7.828h0l1.897.632zm-.01.13h2v.012.012l-2-.025zm.41 1.5L.714 11.134.712 11.13l1.708-1.04zm1.11 1.04l.935-1.768 1.065.563v1.205h-2zm17.18 7.04l1.76.949-.006.012-1.754-.961zm-1.08 1.64l-1.608-1.189.006-.008 1.602 1.197zm-1.12 1.38l1.492 1.332-1.514 1.696-1.49-1.718 1.511-1.31zm-1.7-2.22l1.668-1.104.001.002-1.669 1.102zm-.06-5.24l1.02 1.721-.007.004-.007.004-1.006-1.728zm-1.26 1.25l-1.726-1.01.004-.006.004-.006 1.719 1.023zm.25 3.83l1.734-.997h0l-1.734.996zm1.43 2.07l-1.564 1.246-.007-.009 1.571-1.238zm1 1.19l-1.414 1.414-.044-.044-.041-.046 1.499-1.324zm.02.02l1.414-1.414h0L18.19 22.09zm.6 0l-1.573-1.236.074-.094.085-.085 1.414 1.414zm.04-.04l1.495 1.329-.039.044-.042.042-1.414-1.414zm1.03-1.22l1.567 1.243-.003.004-1.564-1.246zm1.41-2.04l-1.738-.99.005-.008 1.733.998zM7.13 13.77h-2v-2h2v2zm3.26 0v-2h2v2h-2zM2.85 6.99h3.88v4H2.85v-4zM8.7 9.333a3.96 3.96 0 0 1-.713 1.675L4.762 8.642l3.938.69zm-.713 1.675c-.364.496-.826.893-1.366 1.179L4.748 8.653l3.24 2.355zm-1.366 1.179a3.88 3.88 0 0 1-1.832.453v-4l-.031.008 1.863 3.539zm-1.832.453a3.88 3.88 0 0 1-1.832-.453l1.874-3.534c-.016-.007-.022-.009-.028-.01L4.79 12.64zm-1.832-.453c-.54-.287-1.002-.683-1.366-1.179l3.226-2.365-1.86 3.545zm-1.366-1.179A3.96 3.96 0 0 1 .88 9.333l3.941-.685-3.228 2.36zM5.39 1.73h13.06v4H5.39v-4zm14.829 1.068l2.34 4.44-3.539 1.865-2.34-4.44 3.539-1.865zm.571 7.373H3.07v-4h17.72v4zM1.297 7.244l2.32-4.44 3.545 1.852-2.32 4.44-3.545-1.852zm17.975 5.424c-.531.027-1.05-.053-1.545-.231l1.355-3.764.19 3.994zm-1.545-.231c-.476-.171-.92-.427-1.31-.775l2.664-2.984c-.018-.013-.014-.01 0-.005l-1.355 3.764zm-1.349-.811a4.07 4.07 0 0 1-1.239-2.293l3.941-.685c.002.014.005.022.006.025.011.018.02.028.035.042l-2.743 2.911zm.732-4.636h3.92v4h-3.92v-4zm5.897 2.301c-.092.602-.313 1.168-.664 1.674l-3.287-2.279 3.951.605zm-.664 1.674c-.347.5-.794.906-1.323 1.204L19.06 8.682l3.284 2.283zm-1.323 1.204c-.548.308-1.146.474-1.765.5l-.17-3.996-.026.01 1.961 3.486zm-6.508.499c-.531.027-1.05-.053-1.545-.231l1.355-3.764.19 3.994zm-1.545-.231c-.476-.171-.92-.427-1.31-.775l2.664-2.984c-.018-.013-.014-.01 0-.005l-1.355 3.764zm-1.349-.811a4.07 4.07 0 0 1-1.239-2.293l3.941-.685c.003.014.005.022.006.025.011.018.02.028.035.042l-2.743 2.911zm.732-4.636h3.92v4h-3.92v-4zm5.897 2.301c-.092.602-.313 1.168-.664 1.674l-3.287-2.279 3.951.605zm-.664 1.674c-.347.5-.794.906-1.323 1.204L14.3 8.682l3.284 2.283zm-1.323 1.204c-.548.308-1.146.474-1.766.5l-.17-3.996-.025.01 1.961 3.486zm-6.752.481a3.97 3.97 0 0 1-1.79-.463l1.874-3.534-.083 3.997zm-1.79-.463c-.54-.287-1.002-.683-1.366-1.179l3.226-2.365-1.86 3.545zm-1.366-1.179a3.96 3.96 0 0 1-.713-1.675l3.941-.685-3.228 2.36zM7.61 6.99h3.88v4H7.61v-4zm5.85 2.343a3.93 3.93 0 0 1-.728 1.689L9.527 8.628l-.008.019 3.941.685zm-.728 1.689c-.364.488-.824.881-1.361 1.165L9.498 8.653c.012-.006.016-.01.017-.011l3.217 2.38zm-1.361 1.165a3.95 3.95 0 0 1-1.779.463L9.507 8.65l1.864 3.537zm3.138 9.723H4.35v-4h10.16v4zm-12.16-2v-8.5h4v8.5h-4zM4.633 9.43l.148.018c.034.003.034.002.009.002v4c-.247 0-.502-.029-.723-.06l.566-3.96zm.13.02a.75.75 0 0 0 .396-.11l2.042 3.439a4.75 4.75 0 0 1-2.384.67l-.053-4zm.4-.113a.82.82 0 0 0 .294-.301l3.425 2.066c-.418.693-.983 1.264-1.686 1.679L5.163 9.338zm3.717-.305c.075.124.169.218.305.3l-2.05 3.435c-.69-.412-1.257-.971-1.675-1.66l3.42-2.074zm.321.309c.121.073.234.106.376.108l-.053 4c-.858-.011-1.671-.245-2.404-.692l2.081-3.416zm.322.108c.14-.002.262-.034.396-.112l2.002 3.463a4.77 4.77 0 0 1-2.344.648l-.055-4zm.381-.103c.133-.079.233-.175.317-.308l3.379 2.14a4.9 4.9 0 0 1-1.663 1.612L9.903 9.348zm3.734-.245a.8.8 0 0 0 .158.188l-2.691 2.96a4.79 4.79 0 0 1-.922-1.132l3.455-2.015zm.148.179c.083.074.165.123.254.157l-1.439 3.732c-.551-.212-1.049-.52-1.486-.913l2.672-2.977zm.254.157a.73.73 0 0 0 .271.051v4a4.73 4.73 0 0 1-1.709-.319l1.439-3.732zm.271.051h.14v4h-.14v-4zm.054.002c.124-.005.234-.036.358-.112l2.074 3.42a4.71 4.71 0 0 1-2.262.688l-.171-3.996zm.341-.101c.12-.074.204-.16.272-.274l3.425 2.067c-.398.66-.934 1.201-1.588 1.606l-2.109-3.399zm3.674-.312c.048.076.083.122.103.146s.016.015-.016-.011l-2.513 3.112c-.401-.324-.71-.723-.952-1.105l3.378-2.142zm.167.203c.083.074.165.123.253.157l-1.439 3.732c-.551-.212-1.049-.52-1.487-.913l2.672-2.977zm.253.157a.73.73 0 0 0 .271.051v4a4.73 4.73 0 0 1-1.709-.319l1.439-3.732zm.271.051h.14v4h-.14v-4zm.032.003a.74.74 0 0 0 .384-.124l2.169 3.361a4.74 4.74 0 0 1-2.336.756l-.216-3.994zm.385-.124c.105-.068.193-.156.271-.299L23.262 11c-.388.704-.927 1.292-1.609 1.731l-2.166-3.363zm.271-.299c.065-.117.094-.23.092-.372l4-.055c.011.831-.186 1.629-.588 2.358L19.758 9.07zm.139-.833c-.045.201-.119.816.351 1.403l3.123-2.499c.576.72.529 1.523.431 1.963l-3.905-.868zm.14 1.081l-2.74-5.24 3.545-1.854 2.74 5.24-3.545 1.853zm-2.69-5.149a1.54 1.54 0 0 0 .524.524c.282.172.581.238.838.238v-4c.95 0 1.683.528 2.082 1.203l-3.444 2.035zm1.362.763H5.15v-4h13.56v4zm-13.56 0a1.58 1.58 0 0 0 .809-.225l-2.058-3.43A2.42 2.42 0 0 1 5.15.93v4zm.809-.225c.275-.165.539-.439.688-.812L2.933 2.407c.203-.507.559-.887.968-1.132l2.058 3.43zm.604-.63l-2.74 5.25L.277 7.475l2.74-5.25 3.546 1.851zM3.464 9.814c-.225.225-.71.596-1.434.596v-4c-.711 0-1.183.364-1.394.576l2.828 2.828zM4.03 8.41v.02h-4v-.02h4zm-.103.652l-.01.03L.123 7.828l.01-.03 3.795 1.265zm-.01.03a1.77 1.77 0 0 0 .056-.213c.017-.087.036-.215.036-.37h-4a2.16 2.16 0 0 1 .113-.682l3.795 1.265zm.093-.582v.08h-4v-.08h4zm0 .105c-.002.166.034.297.119.435L.712 11.13C.236 10.348-.001 9.479.01 8.565l4 .049zm.116.431c.084.138.187.235.339.316l-1.869 3.536c-.781-.413-1.419-1.009-1.881-1.764l3.412-2.088zM5.53 11.13v9.18h-4v-9.18h4zm0 9.18c0-.204-.04-.423-.132-.638s-.215-.377-.334-.496l-2.828 2.828c-.43-.43-.706-1.022-.706-1.694h4zm-.466-1.134c-.119-.119-.284-.243-.496-.334s-.434-.132-.638-.132v4c-.672 0-1.264-.276-1.694-.706l2.828-2.828zM3.93 18.71h10.58v4H3.93v-4zm10.58 0c-.183 0-.398.033-.62.127s-.403.227-.539.369l2.888 2.768a2.38 2.38 0 0 1-1.729.736v-4zm-1.159.496a1.55 1.55 0 0 0-.427.978l3.993.242a2.44 2.44 0 0 1-.677 1.548l-2.888-2.768zm-.427.978c-.013.206.014.45.112.7s.243.444.39.585l2.768-2.888a2.34 2.34 0 0 1 .723 1.845l-3.993-.242zm.502 1.285a1.6 1.6 0 0 0 .533.337c.204.078.396.104.551.104v-4c.589 0 1.199.206 1.684.671l-2.768 2.888zm9.764-4.719c0 .867-.361 1.704-.72 2.369l-3.521-1.899c.124-.229.192-.39.226-.491.037-.109.015-.09.015.02h4zm-.726 2.381c-.325.592-.741 1.22-1.232 1.876l-3.204-2.394c.416-.557.719-1.023.928-1.404l3.508 1.922zm-1.226 1.868l-1.236 1.522-2.985-2.663 1.004-1.238 3.216 2.379zM16.999 22.5c-.702-.81-1.324-1.619-1.858-2.428l3.338-2.205a19.48 19.48 0 0 0 1.542 2.012L16.999 22.5zm-1.857-2.426c-.364-.55-.675-1.088-.9-1.603-.214-.49-.413-1.095-.413-1.742h4c0-.14-.035-.118.077.138.102.232.281.561.57.997l-3.335 2.208zM13.83 16.73c0-.833.21-1.631.634-2.355l3.452 2.021a.62.62 0 0 0-.086.335h-4zm.634-2.355a4.68 4.68 0 0 1 1.691-1.691l2.021 3.452c-.114.067-.193.145-.259.259l-3.452-2.021zm1.691-1.691c.724-.424 1.523-.634 2.355-.634v4c-.141 0-.239.03-.335.086l-2.021-3.452zm2.355-.634a4.66 4.66 0 0 1 1.787.351l-1.525 3.698c-.074-.031-.156-.049-.262-.049v-4zm1.787.351a4.65 4.65 0 0 1 1.522 1.02l-2.828 2.828c-.077-.077-.148-.121-.218-.15l1.525-3.698zm1.522 1.02c.443.443.789.961 1.025 1.545l-3.709 1.499c-.031-.076-.074-.144-.145-.215l2.828-2.828zm1.025 1.545a4.74 4.74 0 0 1 .346 1.784h-4c0-.106-.018-.197-.054-.286l3.709-1.499zm-3.289.719a1.45 1.45 0 0 0-.481-.321l1.53-3.696a5.45 5.45 0 0 1 1.779 1.189l-2.828 2.828zm-.481-.321c-.185-.077-.369-.113-.565-.113v-4c.724 0 1.427.14 2.095.417l-1.53 3.696zm-.565-.113a1.39 1.39 0 0 0-.74.201l-2.039-3.441a5.39 5.39 0 0 1 2.78-.759v4zm-.754.208c-.231.135-.407.308-.548.544l-3.438-2.045c.486-.817 1.15-1.477 1.972-1.956l2.013 3.457zm-.54.532c-.141.24-.206.482-.206.76h-4c0-.989.255-1.927.754-2.78l3.452 2.021zm-.206.76c0-.033-.005.037.068.242a5.19 5.19 0 0 0 .396.821l-3.468 1.993c-.535-.931-.996-1.993-.996-3.057h4zm.464 1.064c.299.52.716 1.129 1.267 1.829l-3.142 2.475c-.635-.807-1.172-1.578-1.593-2.311l3.468-1.992zm1.26 1.82l.935 1.112-2.998 2.648-1.065-1.268 3.129-2.492zm.85 1.022l.02.02-2.828 2.828-.02-.02 2.828-2.828zm.02.02c-.187-.187-.57-.446-1.114-.446v4c-.757 0-1.34-.352-1.714-.726l2.828-2.828zm-1.114-.446c-.186 0-.424.035-.676.153s-.455.291-.597.472l3.145 2.471a2.36 2.36 0 0 1-1.873.904v-4zm-1.114.446l.04-.04 2.828 2.828-.04.04-2.828-2.828zm-.041.046l.96-1.137 3.129 2.492-1.099 1.303-2.99-2.657zm.958-1.134c.542-.684.95-1.279 1.24-1.788l3.475 1.98c-.417.731-.949 1.497-1.58 2.292l-3.134-2.485zm1.244-1.796c.198-.343.319-.608.387-.802.07-.2.066-.269.066-.239h4c0 1.061-.455 2.115-.987 3.038l-3.466-1.997zm.453-1.042c0-.218-.039-.407-.113-.585l3.696-1.53c.28.675.417 1.386.417 2.115h-4zm-.113-.585a1.45 1.45 0 0 0-.321-.481l2.828-2.828a5.45 5.45 0 0 1 1.189 1.779l-3.696 1.53zM18.51 19.33a2.56 2.56 0 0 1-1.824-.756l2.828-2.828c-.113-.113-.267-.225-.461-.306s-.382-.11-.543-.11v4zm-1.824-.756a2.56 2.56 0 0 1-.756-1.824h4c0-.161-.03-.35-.11-.544s-.192-.347-.306-.461l-2.828 2.828zm-.756-1.824c0-.692.268-1.337.756-1.824l2.828 2.828c.113-.113.226-.267.306-.461s.11-.382.11-.544h-4zm.756-1.824a2.56 2.56 0 0 1 1.824-.756v4c.161 0 .35-.03.543-.11s.347-.192.461-.306l-2.828-2.828zm1.824-.756a2.56 2.56 0 0 1 1.824.756l-2.828 2.828c.113.113.267.226.461.306s.382.11.544.11v-4zm1.824.756c.488.488.756 1.133.756 1.824h-4c0 .161.03.35.11.544s.192.347.306.461l2.828-2.828zm.756 1.824a2.56 2.56 0 0 1-.756 1.824l-2.828-2.828c-.113.113-.226.267-.306.461s-.11.382-.11.544h4zm-.756 1.824a2.56 2.56 0 0 1-1.824.756v-4c-.161 0-.35.03-.544.11s-.347.193-.461.306l2.828 2.828zM18.51 17.35a.61.61 0 0 0 .156-.021.59.59 0 0 0 .139-.056l-1.979-3.476a3.38 3.38 0 0 1 1.684-.447v4zm.294-.077c.039-.022.084-.055.127-.097a.6.6 0 0 0 .096-.122l-3.453-2.019c.303-.518.728-.94 1.252-1.239l1.979 3.476zm.222-.219a.62.62 0 0 0 .061-.148c.016-.06.022-.116.022-.161h-4c0-.606.158-1.188.463-1.709l3.453 2.019zm.083-.309c0-.046-.006-.102-.022-.161a.62.62 0 0 0-.061-.148l-3.453 2.019c-.305-.522-.463-1.103-.463-1.709h4zm-.083-.309c-.018-.031-.045-.069-.083-.107a.57.57 0 0 0-.113-.089l-2.042 3.439c-.508-.302-.92-.719-1.216-1.225l3.453-2.019zm-.195-.195c-.045-.027-.1-.051-.162-.068s-.117-.022-.159-.022v4c-.605 0-1.192-.156-1.721-.47l2.042-3.439zm-.321-.09a.57.57 0 0 0-.141.019c-.055.015-.104.035-.143.058l1.979 3.476a3.4 3.4 0 0 1-1.694.447v-4zm-.284.077c-.041.023-.089.058-.135.104a.64.64 0 0 0-.104.135l3.476 1.979c-.301.529-.73.958-1.259 1.259l-1.979-3.476zm-.239.239c-.024.043-.047.096-.062.156s-.02.114-.02.155l4-.053a3.36 3.36 0 0 1-.442 1.721l-3.476-1.979zm-.082.311c0 .038.006.087.021.141s.036.101.057.138l3.453-2.019a3.41 3.41 0 0 1 .468 1.688l-4 .053zm.078.278a.58.58 0 0 0 .09.115.62.62 0 0 0 .126.097l2.002-3.463c.52.3.937.722 1.236 1.232l-3.453 2.019zm.216.212c.04.023.091.045.151.061s.115.022.16.022v-4c.598 0 1.173.154 1.691.454l-2.002 3.463zM5.13 19.91v-6.14h4v6.14h-4zm2-8.14h3.26v4H7.13v-4zm5.26 2v6.14h-4v-6.14h4zm0 6.14c0-.172-.03-.378-.117-.592s-.214-.397-.354-.537l-2.828 2.828c-.47-.47-.701-1.082-.701-1.699h4zm-.471-1.129c-.14-.14-.321-.267-.537-.354s-.42-.117-.592-.117v4c-.617 0-1.229-.231-1.699-.701l2.828-2.828zm-1.129-.471c-.172 0-.378.03-.592.117s-.397.214-.537.354l2.828 2.828c-.47.47-1.082.701-1.699.701v-4zm-1.129.471c-.14.14-.267.321-.354.537s-.117.42-.117.592h4c0 .617-.23 1.229-.701 1.699l-2.828-2.828zM9.19 19.91v-6.54h4v6.54h-4zm0-6.54c0 .173.03.378.117.592s.214.397.354.537l2.828-2.828c.47.47.701 1.082.701 1.699h-4zm.471 1.129c.14.14.321.267.537.354s.42.117.592.117v-4c.617 0 1.229.23 1.699.701l-2.828 2.828zm1.129.471H6.73v-4h4.06v4zm-4.06 0a1.59 1.59 0 0 0 .592-.117c.216-.087.397-.214.537-.354l-2.828-2.828c.47-.47 1.082-.701 1.699-.701v4zm1.129-.471c.14-.14.267-.321.354-.537s.117-.42.117-.592h-4c0-.617.231-1.229.701-1.699l2.828 2.828zm.471-1.129v6.54h-4v-6.54h4zm0 6.54a1.59 1.59 0 0 0-.117-.592c-.087-.216-.214-.397-.354-.537l-2.828 2.828c-.47-.47-.701-1.082-.701-1.699h4zm-.471-1.129c-.14-.14-.321-.267-.537-.354s-.42-.117-.592-.117v4c-.617 0-1.229-.231-1.699-.701l2.828-2.828zM6.73 18.31c-.173 0-.378.03-.592.117s-.397.214-.537.354l2.828 2.828c-.47.47-1.082.701-1.699.701v-4zm-1.129.471c-.14.14-.267.321-.354.537a1.59 1.59 0 0 0-.117.592h4c0 .617-.231 1.229-.701 1.699l-2.828-2.828z" fill="#b7a37b" mask="url(#A)"/></g><defs><clipPath id="B"><path fill="#fff" transform="matrix(1 0 0 -1 2 22.6699)" d="M0 0h20v20H0z"/></clipPath></defs></svg>';

		// Přidání odkazu na první místo
		navigationButtons.insertBefore(newLink, navigationButtons.firstChild);
	}

	const loginButton = document.querySelector('.top-nav-button-account') || document.querySelector('.top-nav-button-login')
	if (navigationButtons && loginButton) navigationButtons.prepend(loginButton)

	// loginButton.textContent = '';
	const topNavigationBarMenu = document.querySelector('.top-navigation-menu')
	// const helper = document.createElement('div');
	// helper.classList.add('wrapper');
	const headerCont = document.querySelector('#header .container')
	if (window.innerWidth >= 1100) {
		if (search && navigation) {
			navigation.appendChild(search)
		}
	} else {
		if (search) {
			headerCont.appendChild(search)
		}
	}
	// if (!document.querySelector("body").classList.contains("ordering-process")) {
	// 	if (window.innerWidth >= 1100) {

	// 		console.log(window.innerWidth);

	// 		console.log('a');
	// 		navigation.appendChild(navigationButtons);
	// 	}
	// }
	document.querySelectorAll('*').forEach((el) => {
		if (el.offsetWidth > document.documentElement.offsetWidth) {
			console.log('Overflow element: ', el)
		}
	})

	// helper.appendChild(navigationButtons);

	const siteHeader = document.querySelector('#header')
	const navigationIn = document.querySelector('.navigation-in')
	if (window.innerWidth >= 1100) {
		if (topNavigationBarMenu && navigation) {
			headerTopW.appendChild(topNavigationBarMenu)
		}
	} else {
		navigationIn.appendChild(topNavigationBarMenu)
	}


	const cartCount = document.querySelector('.cart-count');
	if (cartCount) {
		const icon = cartCount.querySelector('i');
		if (!icon) {
			const cartPrice = document.querySelector('.cart-price');
			if (cartPrice) {
				const k = kosik.find((item) => item.language === shoptetLang);
				if (k) {
					cartPrice.innerHTML = k.text;
				}
			}
		}
	}

	// if (window.innerWidth <= 1100) {
	// 	setTimeout(() => {
	// 		const allMenuLevel2 = document.querySelectorAll('.menu-level-1 li.ext');

	// 		allMenuLevel2.forEach(menuLevel2 => {
	// 			const link1 = menuLevel2.querySelector('a[data-testid="headerMenuItem"]');

	// 			const menuLevel2Helper = menuLevel2.querySelector('.menu-level-2-helper');
	// 			// console.log(link1.href);

	// 			// Create a new link
	// 			const backToggle = document.createElement('a');
	// 			backToggle.textContent = "zpět";
	// 			backToggle.classList.add('back-toggle');

	// 			// Add the new link at the beginning of menuLevel2Helper
	// 			menuLevel2Helper.insertBefore(backToggle, menuLevel2Helper.firstChild);

	// 			// Create a new link that inherits properties from link1
	// 			// const newLink = document.createElement('a');
	// 			// const oldHref = link1.href;
	// 			// newLink.href = oldHref;
	// 			// newLink.textContent = `Zobrazit vše v ${link1.innerHTML}`;
	// 			// newLink.classList = link1.classList;
	// 			// newLink.classList.add('redirect-to-orig');

	// 			// Add the new link after backToggle
	// 			// menuLevel2Helper.insertBefore(newLink, backToggle.nextSibling);

	// 			document.addEventListener('click', (e) => {
	// 				const link1 = e.target.closest('.link1');
	// 				if (link1) {
	// 					e.preventDefault();
	// 					menuLevel2.classList.add('active');
	// 				}

	// 				const backToggle = e.target.closest('.back-toggle');
	// 				if (backToggle) {
	// 					e.preventDefault();
	// 					menuLevel2Helper.classList.remove('active');
	// 				}
	// 			});

	// 		});
	// 	}, 1000);
	// }

	const searchButton = document.querySelector('.toggle-window[data-target="search"]')
	if (navigationButtons && searchButton) navigationButtons.prepend(searchButton)
	const navButtons = document.querySelector('.navigation-buttons')
	const menuTrigger = document.querySelector('.toggle-window[data-target="navigation"]')
	if (menuTrigger && navButtons) navButtons.appendChild(menuTrigger)

	if (window.innerWidth > 1100) {
		const menuLvl2s = document.querySelectorAll('#navigation .menu-level-2')
		menuLvl2s.forEach((menuLvl2) => {
			const helper = document.createElement('div')
			helper.classList.add('menu-level-2-helper')
			menuLvl2.parentElement.insertBefore(helper, menuLvl2)
			helper.appendChild(menuLvl2)
		})
	}
	// const menuLvL2Li = document.querySelectorAll('.menu-level-2 > li')
	// menuLvL2Li.forEach((li) => {
	// 	const innerImg = li.querySelector('.menu-image > img')
	// 	const toRemove = li.querySelector('.menu-image')
	// 	const targetA = li.querySelector('div > a')
	// 	if (innerImg && toRemove) {
	// 		if (innerImg.getAttribute('data-src'))
	// 			innerImg.setAttribute('data-src', innerImg.getAttribute('data-src').replace('/thumb/', '/orig/'))
	// 		if (innerImg.getAttribute('src')) innerImg.setAttribute('src', innerImg.getAttribute('src').replace('/thumb/', '/orig/'))
	// 		const imgWrap = document.createElement('div')
	// 		imgWrap.classList.add('menu-image')
	// 		imgWrap.appendChild(innerImg)
	// 		targetA.prepend(imgWrap)
	// 		toRemove.remove()
	// 	}
	// })

	const topBanner = document.querySelector('.top-panel-text-wrapper')
	const topNavigation = document.querySelector('.top-navigation-bar .container')
	if (topBanner && topNavigation) {
		topNavigation.appendChild(topBanner)
	}
	// const profeseLi =
	// 	window.innerWidth > 767
	// 		? document.querySelectorAll('.navigation-in a[href="/podle-profese/"] + .menu-level-2-helper .menu-level-3 > li')
	// 		: document.querySelectorAll('.navigation-in .menu-level-3 > li')
	// profeseLi.forEach((li) => {
	// 	const help = li.querySelector('a')
	// 	li.innerHTML = ''
	// 	li.appendChild(help)
	// })

	let initialYScroll = 0
	const debouncedScroll = debounce(function () {
		const header = document.querySelector('#header')
		const headerOffsetTop = header.offsetTop
		const windowScrollTop = window.scrollY
		// const header2 = document.querySelector('.user-action-cart')
		const login = document.querySelector('.user-action-login')
		// if (headerOffsetTop <= windowScrollTop) {
		// 	header.classList.add('sticky')
		// } else {
		// 	header.classList.remove('sticky')
		// }
		// if (window.innerWidth > 1100) {
		if (windowScrollTop > initialYScroll) {
			header.classList.remove('scroll-up')
			header.classList.add('scroll-down')
			login.classList.add('sticky');
			// header2.classList.add('sticky');
		} else {
			header.classList.remove('scroll-down')
			header.classList.add('scroll-up')
			login.classList.remove('sticky');
			// header2.classList.remove('sticky');
		}
		// }
		initialYScroll = windowScrollTop
	}, 100)

	window.addEventListener('scroll', debouncedScroll)

	const headerTop = document.querySelector('#header .header-top')
	if (headerTop) header.style.setProperty('--header-top-height', `${headerTop.clientHeight}px`)

	let liElements = document.querySelectorAll('.menu-level-3 li')

	liElements.forEach((li) => {
		let childNodes = Array.from(li.childNodes)
		childNodes.forEach((node) => {
			if (node.nodeType === 3 && node.textContent.includes(',')) {
				// 3 is a Text node
				node.textContent = node.textContent.replace(',', '')
			}
		})
	})

	// const headerBanner = document.querySelector('.custom-footer__banner1')
	// if (headerBanner) {
	// 	const allMenuLevel2Helpers = document.querySelectorAll('.menu-level-1 li.ext .menu-level-2-helper')
	// 	allMenuLevel2Helpers.forEach((helper) => {
	// 		const clone = headerBanner.cloneNode(true) // true means it will clone the node and its child nodes
	// 		helper.appendChild(clone)
	// 	})
	// }
}
handleHeader()
document.addEventListener('ShoptetDOMPageContentLoaded', handleHeader)
document.addEventListener('ShoptetDOMContentLoaded', handleHeader)
function highlightCurrentCurrency() {
	const currentCurrency = dataLayer[0].shoptet.currency
	const currencyLinks = document.querySelectorAll('.top-navigation-tools .dropdown ul li a')

	currencyLinks.forEach((link) => {
		if (link.innerHTML.trim() === currentCurrency) {
			link.classList.add('active')
		}
	})
}

highlightCurrentCurrency()
document.addEventListener('ShoptetDOMPageContentLoaded', highlightCurrentCurrency)
document.addEventListener('ShoptetDOMContentLoaded', highlightCurrentCurrency)
// const handleCarouselThumbnails = () => {
// 	const carousel = document.querySelector('#carousel')
// 	if (carousel) {
// 		const carouselItems = carousel.querySelectorAll('.item')
// 		const thumbnails = []
// 		carouselItems.forEach((item) => {
// 			const itemImage = item.querySelector('img')
// 			const itemTitle = itemImage.getAttribute('alt')
// 			const itemThumbnail = document.createElement('div')
// 			itemThumbnail.classList.add('carousel-thumbnail')
// 			itemThumbnail.innerHTML = `
// 				<img src="${itemImage.getAttribute('src') || itemImage.getAttribute('data-src')}" alt="${itemTitle}" />
// 				<span class="carousel-thumbnail-title">${itemTitle}</span>
// 			`
// 			thumbnails.push(itemThumbnail)
// 		})
// 		if (thumbnails.length > 1) {
// 			const carouselThumbnails = document.createElement('div')
// 			carouselThumbnails.classList.add('carousel-thumbnails')
// 			thumbnails.forEach((thumbnail, index) => {
// 				carouselThumbnails.appendChild(thumbnail)
// 				if (index === 0) thumbnail.classList.add('active')
// 				thumbnail.addEventListener('click', (e) => {
// 					e.preventDefault()
// 					document.querySelector('.carousel-inner .item.active').classList.remove('active')
// 					document.querySelector('.carousel-thumbnails .carousel-thumbnail.active').classList.remove('active')
// 					let targetItem = document.querySelectorAll('.carousel-inner .item')[index]
// 					const targetItemImg = targetItem.querySelector('img')
// 					if (!targetItemImg.src) targetItemImg.src = targetItemImg.getAttribute('data-src')
// 					targetItem.classList.add('active')
// 					thumbnail.classList.add('active')
// 				})
// 			})
// 			carousel.parentElement.insertBefore(carouselThumbnails, carousel.nextElementSibling)
// 		}
// 	}
// }
// handleCarouselThumbnails()

// const handleTopCategories = () => {
// 	const topCategories = document.querySelector('.top-categories')
// 	const firstProductsBlock = document.querySelector('.products-block')
// 	if (topCategories && firstProductsBlock)
// 		firstProductsBlock.parentElement.insertBefore(topCategories, firstProductsBlock.nextElementSibling)
// }
// if (shoptetPage === 'homepage') handleTopCategories()


const handleCategory = async (reload = false) => {
	const categoryTopDuplicate = document.querySelector('#content-wrapper > .category-top-wrapper')
	const categoryTop = document.querySelector('#content .category-top')
	const categoryContentWrapper = document.querySelector('#content-wrapper')
	const subcategories = document.querySelector('#content .subcategories')
	const categoryUSP = document.querySelector('.benefitBanner')
	if (categoryTopDuplicate) {
		if (categoryTop) categoryTop.remove()
		if (subcategories) subcategories.remove()
	} else {
		const categoryTopContainer = document.createElement('div')
		categoryTopContainer.classList.add('category-top-wrapper')
		categoryTopContainer.appendChild(categoryTop)
		if (categoryTop) categoryContentWrapper.prepend(categoryTopContainer)
		// if (categoryTop && subcategories) categoryTop.parentElement.insertBefore(subcategories, categoryTop.nextElementSibling)
		// console.log(allImg)
		const imageWrapper = document.createElement('div')
		imageWrapper.classList.add('category-image')
		const categoryImage = categoryTop.querySelector('p > img') || categoryTop.querySelector('p > span > img')
		const allImg = categoryTop.querySelectorAll("p > img") || categoryTop.querySelectorAll('p > span > img');

		if (categoryImage) {
			// const toRemove = categoryImage.closest('p')
			// imageWrapper.appendChild(categoryImage);

			const windowWidth = window.innerWidth;

			allImg.forEach((img, index) => {
				// Vytvoření nové instance Image
				console.log(index);

				if (index === 1) {
					img.style.display = "block";
				}
				const tempImg = new Image();

				tempImg.src = img.src;

				tempImg.onload = function () {
					const imgWidth = tempImg.naturalWidth;

					if ((windowWidth > 768 && imgWidth < 800) || (windowWidth <= 768 && imgWidth > 800)) {
						img.style.display = "none";
					} else {
						img.style.display = "block";
					}

					// Přidání obrázku do wrapperu po zpracování jeho rozměrů
					imageWrapper.appendChild(img);
				};
			});
			// toRemove.remove()
		} else {
			const categoryVideo = document.querySelector('p > video')
			if (categoryVideo) {
				const toRemove = categoryVideo.closest('p')
				imageWrapper.appendChild(categoryVideo)
				categoryVideo.removeAttribute('controls')
				categoryVideo.setAttribute('preload', 'auto')
				// categoryVideo.width = '454'
				// categoryVideo.height = '278'
				toRemove.remove()
				const playVideoButton = document.createElement('button')
				playVideoButton.classList.add('play-video')
				// playVideoButton.innerHTML = `<img src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/worksafety/assets/img/play-video.png" alt="Přehrát video" width="167" height="124" />`
				imageWrapper.appendChild(playVideoButton)
				playVideoButton.addEventListener('click', () => {
					categoryVideo.play()
					playVideoButton.remove()
					categoryVideo.setAttribute('controls', '')
				})
			}
		}
		categoryTop.prepend(imageWrapper)
		const categoryTopBG = document.querySelector('#data-background')
		if (categoryTopBG) {
			categoryTopContainer.style.backgroundColor = categoryTopBG.getAttribute('data-background')
			categoryTopBG.remove()
		}
	}
	if (categoryTop) {
		const emptyParagraphs = categoryTop.querySelectorAll('p');
		console.log(emptyParagraphs);
		if (emptyParagraphs.length > 0) {
			emptyParagraphs.forEach(emptyParagraph => {
				if (!emptyParagraph.textContent.trim()) {
					emptyParagraph.remove();
				}
			});
		}
	}

	// if (categoryUSP) {
	// 	const subcategoriesHelp = document.querySelector('.subcategories')
	// 	const categoryTopHelp = document.querySelector('.category-top')
	// 	if (subcategoriesHelp) {
	// 		subcategoriesHelp.parentElement.insertBefore(categoryUSP, subcategoriesHelp.nextElementSibling)
	// 	} else if (categoryTopHelp) {
	// 		categoryTopHelp.parentElement.insertBefore(categoryUSP, categoryTopHelp.nextElementSibling)
	// 	}
	// }
	// if (!reload) {
	// 	const setBackground = (desktopImg, mobileImg) => {
	// 		let desktop = desktopImg
	// 		let mobile = mobileImg
	// 		if (!desktop) desktop = mobileImg
	// 		if (!mobile) mobile = desktopImg
	// 		document.body.classList.add('has-background')
	// 		categoryTop.style.backgroundImage = window.innerWidth > 767 ? `url(${desktopImg})` : `url(${mobileImg})`
	// 	}
	// 	const categoryBG = categoryTop.querySelectorAll('p > img')
	// 	if (categoryBG.length) {
	// 		let desktopImg
	// 		let mobileImg
	// 		let imagesLoading = []
	// 		categoryBG.forEach((img) => {
	// 			console.log(img)
	// 			imagesLoading.push(
	// 				new Promise((resolve) => {
	// 					if (img.complete) {
	// 						console.log(img, img.naturalWidth)
	// 						if (img.naturalWidth > 1000) desktopImg = img.src
	// 						if (img.naturalWidth <= 1000) mobileImg = img.src
	// 						img.closest('p').remove()
	// 						resolve()
	// 					} else {
	// 						img.addEventListener('load', () => {
	// 							console.log(img, img.naturalWidth)
	// 							if (img.naturalWidth > 1000) desktopImg = img.src
	// 							if (img.naturalWidth <= 1000) mobileImg = img.src
	// 							img.closest('p').remove()
	// 							resolve()
	// 						})
	// 					}
	// 				})
	// 			)
	// 		})
	// 		console.log(imagesLoading)
	// 		Promise.all(imagesLoading)
	// 			.then(() => {
	// 				console.log(desktopImg, mobileImg)
	// 				setBackground(desktopImg, mobileImg)
	// 			})
	// 			.catch(() => {
	// 				console.log('error')
	// 			})
	// 		setTimeout(() => {
	// 			console.log(imagesLoading)
	// 		}, 1000)
	// 	} else {
	// 		document.body.classList.remove('has-background')
	// 	}
	// }
	if (subcategories) {
		const subcategoriesImages = subcategories.querySelectorAll('.image > img')
		subcategoriesImages.forEach((image) => {
			image.src = image.src.replace('/thumb/', '/orig/')
		})

		// const showCategoriesBtn = document.createElement('button')
		// showCategoriesBtn.classList.add('show-categories')
		// showCategoriesBtn.innerHTML = 'Subkategorie'
		// subcategories.prepend(showCategoriesBtn)
		// showCategoriesBtn.addEventListener('click', () => {
		// 	subcategories.classList.toggle('show')
		// })
	}
	// dlouhý (spodní) popis
	const secondDescription = document.querySelector('.category__secondDescription')
	if (secondDescription) {
		secondDescription.id = 'dlouhy-popis'
		const categoryContent = document.querySelector('#content .category-content-wrapper')
		categoryContent.parentElement.insertBefore(secondDescription, categoryContent.nextElementSibling)
	}
	// banery v kategorii
	const categoryBanners = document.querySelectorAll('.banner-category')
	const firstProductBlock = document.querySelector('#products')
	const secondProductBlock = document.querySelector('.products-block:not(#products)')
	if (secondProductBlock) {
		const secondBlockProducts = secondProductBlock.querySelectorAll('.product')
		secondBlockProducts.forEach((product) => {
			if (firstProductBlock) firstProductBlock.appendChild(product)
		})
		secondProductBlock.remove()
	}
	categoryBanners.forEach((categoryBanner, index) => {
		if (categoryBanner && firstProductBlock) {
			categoryBanner.classList.add('product')
			let whereToAppend = null
			switch (index) {
				case 0:
					categoryBanner.classList.add('first'); // Add 'first' class to the first banner
					whereToAppend = firstProductBlock.querySelector('.product:nth-child(3)')
					break
				case 1:
					categoryBanner.classList.add('second'); // Add 'second' class to the second banner
					whereToAppend = firstProductBlock.querySelector('.product:nth-child(9)')
					break
			}
			if (whereToAppend) {
				whereToAppend.after(categoryBanner)
			} else {
				firstProductBlock.appendChild(categoryBanner)
			}
		}
	})

	// const productsAnchor = document.querySelector('.category-top a[href="#products"]')
	// if (productsAnchor) {
	// 	productsAnchor.addEventListener('click', (e) => {
	// 		e.preventDefault()
	// 		e.stopPropagation()
	// 		const products = document.querySelector('#products')
	// 		products.scrollIntoView({ behavior: 'smooth' })
	// 	})
	// }
	// const dlouhyPopisAnchor = document.querySelector('.category-top a[href="#dlouhy-popis"]')
	// if (dlouhyPopisAnchor) {
	// 	dlouhyPopisAnchor.addEventListener('click', (e) => {
	// 		e.preventDefault()
	// 		e.stopPropagation()
	// 		const dlouhyPopis = document.querySelector('.category__secondDescription')
	// 		dlouhyPopis.scrollIntoView({ behavior: 'smooth' })
	// 	})
	// }

	// const unveilFilters = document.querySelector('.filters-unveil-button-wrapper')
	// if (unveilFilters && window.innerWidth <= 767) categoryTop.appendChild(unveilFilters)

	// posunutí buttonu zpět nahoru pod spodní popis
	const categoryBackTop = document.querySelector('.pagination-top')
	if (categoryBackTop) {
		const categorySecondDescription = document.querySelector('.category__secondDescription')
		if (categorySecondDescription) {
			const buttonsWrapper = document.createElement('div')
			buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
			categorySecondDescription.appendChild(buttonsWrapper)
			buttonsWrapper.appendChild(categoryBackTop)
		}
	}




	function createSidebarWithFilters() {
		const asideActive = window.sessionStorage.getItem('asideActive') === 'true';

		if (!document.querySelector('aside.sidebar.new-one')) {
			const asideElement = document.createElement('aside');
			asideElement.classList.add('sidebar', 'new-one');
			if (asideActive) {
				asideElement.classList.add('active');
			}
			const sidebarInner = document.createElement('div');
			sidebarInner.classList.add('sidebar-inner');
			asideElement.appendChild(sidebarInner);
			const filtersWrapper = document.querySelector('.filters-wrapper');
			if (filtersWrapper && sidebarInner) {
				sidebarInner.appendChild(filtersWrapper);
			}

			const contentWrapperIn = document.querySelector('.content-wrapper-in');
			const bodyElement = document.body;
			if (bodyElement.classList.contains('mobile')) {
				const close = document.createElement('div');
				close.classList.add('close', 'sidebar-close');
				sidebarInner.insertBefore(close, sidebarInner.firstChild);
				const mainContent = document.querySelector('main#content');
				if (mainContent) {
					mainContent.insertBefore(asideElement, mainContent.firstChild);
				}
			} else {
				if (contentWrapperIn && asideElement) {
					contentWrapperIn.insertBefore(asideElement, contentWrapperIn.firstChild);
				}
			}
			let filterSectionBoolean = document.querySelector('.filter-section-boolean');
			let categoryFilterHover = document.querySelector('#category-filter-hover');

			if (!categoryFilterHover) {
				// Vytvoření nového prvku
				categoryFilterHover = document.createElement('div');
				categoryFilterHover.id = 'category-filter-hover';

				// Najdeme prvek s třídou .filter-sections
				const filterSections = document.querySelector('.filter-sections');

				if (filterSections) {
					// Vložíme nový prvek do .filter-sections
					filterSections.appendChild(categoryFilterHover);
				} else {
					console.error('Prvek s třídou .filter-sections nebyl nalezen.');
				}
			}

			if (categoryFilterHover) {
				let filterSectionCount = categoryFilterHover.querySelector('.filter-section-count');

				if (filterSectionCount) {
					filterSectionCount.remove();
				}
			}

			setTimeout(() => {
				if (filterSectionBoolean && categoryFilterHover) {
					let forms = filterSectionBoolean.querySelectorAll('form');
					forms.forEach((form, index) => {
						let newFilterSection = document.createElement('div');
						newFilterSection.classList.add('filter-section', 'filter-section-parametric', `filter-section-parametric-id-${index}`, 'hidden');

						let h4 = document.createElement('h4');
						if (index === 0) {
							h4.textContent = 'Dostupnost';
						} else if (index === 1) {
							h4.textContent = 'Štítky';
						}
						newFilterSection.appendChild(h4);
						newFilterSection.appendChild(form);

						// Přidání nového .filter-section na konec #category-filter-hover
						categoryFilterHover.appendChild(newFilterSection);
					});
				}
			}, 100);
		} else if (document.querySelector('aside.sidebar.new-one')) {
		
			const asideElement = document.querySelector('aside.sidebar.new-one');
			if (asideActive) {
				asideElement.classList.add('active');
			}
			const sidebarInner = asideElement.querySelector('.sidebar-inner');
			asideElement.appendChild(sidebarInner);
			const filtersWrapper = document.querySelector('.filters-wrapper');
			if (filtersWrapper && sidebarInner) {
				sidebarInner.appendChild(filtersWrapper);
			}

			const contentWrapperIn = document.querySelector('.content-wrapper-in');
			const bodyElement = document.body;
			if (bodyElement.classList.contains('mobile')) {
				const mainContent = document.querySelector('main#content');
				const close = document.createElement('div');
				close.classList.add('close', 'sidebar-close');
				sidebarInner.insertBefore(close, sidebarInner.firstChild);
				if (mainContent) {
					mainContent.insertBefore(asideElement, mainContent.firstChild);
				}
			} else {
				if (contentWrapperIn && asideElement) {
					contentWrapperIn.insertBefore(asideElement, contentWrapperIn.firstChild);
				}
			}
			let filterSectionBoolean = document.querySelector('.filter-section-boolean');
			let categoryFilterHover = document.querySelector('#category-filter-hover');

			if (!categoryFilterHover) {
				// Vytvoření nového prvku
				categoryFilterHover = document.createElement('div');
				categoryFilterHover.id = 'category-filter-hover';

				// Najdeme prvek s třídou .filter-sections
				const filterSections = document.querySelector('.filter-sections');

				if (filterSections) {
					// Vložíme nový prvek do .filter-sections
					filterSections.appendChild(categoryFilterHover);
				} else {
					console.error('Prvek s třídou .filter-sections nebyl nalezen.');
				}
			}
			if (categoryFilterHover) {
				let filterSectionCount = categoryFilterHover.querySelector('.filter-section-count');

				if (filterSectionCount) {
					filterSectionCount.remove();
				}
			}
			// console.log(filterSectionBoolean);
			// console.log(categoryFilterHover);
			if (filterSectionBoolean && categoryFilterHover) {

				let forms = filterSectionBoolean.querySelectorAll('form');
				forms.forEach((form, index) => {
					let newFilterSection = document.createElement('div');
					newFilterSection.classList.add('filter-section', 'filter-section-parametric', `filter-section-parametric-id-${index}`, 'hidden');

					let h4 = document.createElement('h4');
					if (index === 0) {
						h4.textContent = 'Dostupnost';
					} else if (index === 1) {
						h4.textContent = 'Štítky';
					}
					newFilterSection.appendChild(h4);
					newFilterSection.appendChild(form);

					// Přidání nového .filter-section na konec #category-filter-hover
					categoryFilterHover.appendChild(newFilterSection);
				});
			}
		}
	}

	createSidebarWithFilters();
	// document.addEventListener('ShoptetDOMPageContentLoaded', createSidebarWithFilters);
	// document.addEventListener('ShoptetDOMContentLoaded', createSidebarWithFilters);
	// document.addEventListener('ShoptetPageFilterValueChange', createSidebarWithFilters);

	// const updateFilterClassDisplay = () => {
	// 	const filterSections = document.querySelectorAll('.filter-section-parametric');
	// 	const filterClass = document.querySelector('.filter-class');

	// 	if (filterClass) {
	// 		if (filterSections.length < 4) {
	// 			filterClass.style.display = 'none';
	// 		}
	// 	}
	// }

	// updateFilterClassDisplay();
	// document.addEventListener('ShoptetDOMPageContentLoaded', updateFilterClassDisplay);
	// document.addEventListener('ShoptetDOMPageContentLoaded', updateFilterClassDisplay);


	function moveTopProducts() {
		const topProducts = document.querySelector('#productsTop');
		if (topProducts) {
			const categoryContentMain = document.querySelector('aside.sidebar.new-one');
			if (categoryContentMain) {
				// Najdi nadřazený <h4>
				const nearestH4 = topProducts.previousElementSibling;

				categoryContentMain.insertAdjacentElement('afterend', topProducts);
				if (nearestH4 && nearestH4.tagName === 'H4') {
					categoryContentMain.insertAdjacentElement('afterend', nearestH4);
					nearestH4.style.textAlign = 'center';
					nearestH4.style.margin = '0 auto';
					nearestH4.style.marginBottom = '20px';
				}
			}
		}
	}

	moveTopProducts();
	document.addEventListener('ShoptetDOMPageContentLoaded', moveTopProducts);
	document.addEventListener('ShoptetDOMContentLoaded', moveTopProducts);

	// setTimeout(() => {
	// 	if (window.innerWidth < 900) {
	// 		const categoryContent = document.querySelector('.category-content-wrapper');

	// 		const title = categoryTop.querySelector('.category-title')
	// 		const cats = categoryTop.querySelector('.subcategories')

	// 		const div = document.createElement('div');
	// 		div.classList.add('sub-holder');

	// 		categoryContent.insertBefore(div, categoryContent.firstChild);
	// 		// categoryTopContainer.appendChild(title)
	// 		const showAllCategoriesBtn = document.createElement('div')
	// 		showAllCategoriesBtn.classList.add('show-all-categories')
	// 		showAllCategoriesBtn.textContent = 'Kategorie'

	// 		// Nastavení všech .subcategories li na display: none
	// 		const subcategoriesItem = document.querySelector('.category-top-wrapper .subcategories')
	// 		div.appendChild(showAllCategoriesBtn);
	// 		div.appendChild(cats);
	// 		showAllCategoriesBtn.addEventListener('click', function (event) {
	// 			if (event.target === showAllCategoriesBtn || showAllCategoriesBtn.contains(event.target)) {
	// 				// Přepínání třídy 'active' pro každou položku v subcategoriesItems
	// 				cats.classList.toggle('active')
	// 			}
	// 		})

	// 		// Přidání event listeneru na tlačítko
	// 	}
	// }, 1000);

	const scrollTop = document.querySelector('.pagination-top strong.js-scroll-top');
	if (scrollTop) {
		scrollTop.textContent = "Zpět nahoru";
	}

}

if (shoptetPage === "category") {
	handleCategory()
	document.addEventListener('ShoptetDOMContentLoaded', () => handleCategory(true))

	const addSubcategoryClass = () => {
		const subcategories = document.querySelector('.subcategories');
		const categoryTopWrapper = document.querySelector('.category-top-wrapper');

		if (subcategories && categoryTopWrapper) {
			categoryTopWrapper.classList.add('with-subcategory');
		}
	}

	addSubcategoryClass();
	document.addEventListener('ShoptetDOMContentLoaded', addSubcategoryClass);



	function createFilteringLink() {
		const existingFilterLink = document.querySelector('#filter');
		if (!existingFilterLink) {
			const filteringLink = document.createElement('a');
			const filterSection = document.querySelector("aside #filters .filter-sections");
			if (filterSection) {
				let filterText = "Filtr";
				if (window.innerWidth < 1001) {
					filterText = "Filtr";
				} else {
					filterText = filterBtnText.find(item => item.language === shoptetLang);
				}
				if (filterText) {
					if (window.innerWidth < 1001) {
						filteringLink.innerHTML = filterText;
					} else {
						filteringLink.innerHTML = filterText.text;
					}

					if (window.innerWidth < 1001) {
						filteringLink.classList.add("filtering-btn", "filter-class");
					} else {
						filteringLink.classList.add("filtering-btn", "btn", "btn-primary", "filter-class");
					}
					filterSection.appendChild(filteringLink);
					filteringLink.id = "filter";

					const contentWrapper = document.querySelector('.content-wrapper-in');
					if (window.innerWidth < 1000 && document.body.classList.contains('mobile')) {
						const btnHolderDiv = document.createElement('div');
						btnHolderDiv.classList.add('btn-holder-filter');
						contentWrapper.insertBefore(btnHolderDiv, contentWrapper.firstChild);
						btnHolderDiv.appendChild(filteringLink);
					} else {
						filterSection.appendChild(filteringLink);

					}
				}
			}
		}
	}

	createFilteringLink();
	document.addEventListener('ShoptetDOMPageContentLoaded', createFilteringLink);
	document.addEventListener('ShoptetDOMContentLoaded', createFilteringLink);
	document.addEventListener('ShoptetPageSortingChanged', createFilteringLink);
	window.addEventListener('resize', createFilteringLink);


	document.body.addEventListener('click', (event) => {
		if (event.target.matches('.filter-class')) {
			event.stopPropagation();
			event.stopImmediatePropagation();

			const filterButton = event.target;
			if (!filterButton.classList.contains('active')) {
				filterButton.classList.add('active');

				if (window.innerWidth > 1000) {
					filterButton.innerHTML = filterBtnTextClose.find(item => item.language === shoptetLang)?.text;
				}

				const filterSections = document.querySelectorAll('#category-filter-hover');
				const asideElement = document.querySelector('.type-category aside.sidebar');

				asideElement.classList.add('active');
				filterSections.forEach(section => {
					section.classList.add('active');
				});

				window.sessionStorage.setItem('filterActive', 'true');
				window.sessionStorage.setItem('asideActive', 'true'); // Uložit stav aside
			} else {
				filterButton.classList.remove('active');

				if (window.innerWidth > 1000) {
					filterButton.innerText = filterBtnText.find(item => item.language === shoptetLang)?.text;
				}

				const filterSections = document.querySelectorAll('#category-filter-hover');
				const asideElement = document.querySelector('.type-category aside.sidebar');

				asideElement.classList.remove('active');
				filterSections.forEach(section => {
					section.classList.remove('active');
				});

				window.sessionStorage.setItem('filterActive', 'false');
				window.sessionStorage.setItem('asideActive', 'false'); // Uložit stav aside
			}
		}
	});

	function restoreFilterState() {
		const filterActive = window.sessionStorage.getItem('filterActive');
		const asideActive = window.sessionStorage.getItem('asideActive') === 'true';

		if (filterActive === 'true') {
			const filterButton = document.querySelector('.filter-class');
			if (filterButton) {
				filterButton.classList.add('active');

				if (window.innerWidth > 1000) {
					filterButton.innerHTML = filterBtnTextClose.find(item => item.language === shoptetLang)?.text;
				}
				const filterSections = document.querySelectorAll('#category-filter-hover');
				filterSections.forEach(section => {
					section.classList.add('active');
				});
			}
		}

		// Pozorovatel změn v DOM pro element aside
		const observer = new MutationObserver((mutationsList, observer) => {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const asideElement = document.querySelector('.type-category aside.sidebar');
					if (asideElement) {
						if (window.innerWidth > 1000 && asideActive) {
							asideElement.classList.add('active');
						}
						// Odpojit pozorovatele po nalezení elementu aside
						observer.disconnect();
					}
				}
			}
		});

		// Konfigurace pozorovatele
		const config = { childList: true, subtree: true };

		// Spustit pozorovatele na kořenovém elementu
		observer.observe(document.body, config);
	}

	function saveAsideState() {
		const asideElement = document.querySelector('.type-category aside.sidebar');
		if (asideElement) {
			window.sessionStorage.setItem('asideActive', asideElement.classList.contains('active'));
		}
	}

	document.addEventListener('ShoptetDOMPageContentLoaded', restoreFilterState);
	document.addEventListener('DOMContentLoaded', saveAsideState);
	document.addEventListener('click', saveAsideState); // Save state on click events to capture changes



	function closeSidebar() {
		const closeBtn = document.querySelector('.close.sidebar-close');
		if (closeBtn) {
			closeBtn.addEventListener('click', () => {
				console.log('click');
				const asideElement = document.querySelector('.type-category aside.sidebar');
				if (asideElement) {
					asideElement.classList.remove('active');
				}
			});
		}
	}

	// Volání funkce closeSidebar při načtení stránky nebo po nějaké události
	closeSidebar();

	// Příklad: Volání funkce closeSidebar po spuštění nějakého eventu
	document.addEventListener('ShoptetDOMPageContentLoaded', closeSidebar);


	// const handleCheckedFilters = () => {
	// 	const activeFilters = document.querySelectorAll('#filters input[type="checkbox"]:checked+label');
	// 	const categoryContent = document.querySelector('.content-wrapper-in');

	// 	const existingActiveFilters = categoryContent.querySelector('.active-filters');
	// 	if (existingActiveFilters) existingActiveFilters.remove();

	// 	if (activeFilters.length && categoryContent) {
	// 		let activeFiltersWrapper = document.createElement('div');
	// 		let activeFiltersList = document.createElement('div');

	// 		activeFiltersWrapper.classList.add('active-filters');
	// 		activeFiltersList.classList.add('active-list');

	// 		activeFiltersWrapper.appendChild(activeFiltersList);

	// 		activeFilters.forEach((item) => {
	// 			activeFiltersList.appendChild(item.cloneNode(true));
	// 		});

	// 		let deleteFilters = document.querySelector('#clear-filters');
	// 		if (deleteFilters) activeFiltersWrapper.appendChild(deleteFilters);

	// 		categoryContent.appendChild(activeFiltersWrapper);
	// 	}
	// }

	// handleCheckedFilters();
	// document.addEventListener('ShoptetDOMContentLoaded', handleCheckedFilters);



	const setFilterSectionsZIndex = async () => {
		const filterSections = document.querySelectorAll('.filter-section');
		console.log(filterSections);
		if (filterSections.length > 0) {
			filterSections.forEach((section, index) => {
				section.style.zIndex = 20 - index;
			});
		}
	}

	setFilterSectionsZIndex();
	document.addEventListener('ShoptetDOMContentLoaded', setFilterSectionsZIndex);
	document.addEventListener('ShoptetDOMPageContentLoaded', setFilterSectionsZIndex);
}
const handleFilterEvents = () => {
	const filterSections = document.querySelectorAll('.filter-section');
	if (filterSections.length) {
		filterSections.forEach((section) => {
			let heading = section.querySelector('h4');
			if (heading && !heading.dataset.clickBound) {  // Check if the event is already bound
				heading.dataset.clickBound = true;  // Mark that the click event is bound
				heading.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					section.classList.toggle('filter-form-visible');
					let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
						parentClass = e.currentTarget.parentElement.className;
					parentClass = parentClass.replace('filter-form-visible', '').trim();
					if (cache.includes(parentClass)) {
						cache = cache.filter((item) => item !== parentClass);
					} else {
						cache.push(parentClass);
					}
					window.sessionStorage.setItem('openedFilters', JSON.stringify(cache));
				});
			}
		});
	}

	let helperCache = window.sessionStorage.getItem('openedFilters');
	if (helperCache && helperCache.length) {
		helperCache = JSON.parse(helperCache);
		helperCache.forEach((item) => {
			item = item.replaceAll(' ', '.');
			item = document.querySelector(`.${item}`);
			if (item && !item.classList.contains('filter-form-visible')) {
				item.classList.add('filter-form-visible');
			}
		});
	}
};

if (shoptetPage === 'category') {
	handleFilterEvents();
	document.addEventListener('ShoptetDOMContentLoaded', handleFilterEvents);
}
document.addEventListener('click', (event) => {
	const filterSections = document.querySelectorAll('.filter-section');
	if (!event.target.closest('.filter-section')) {
		filterSections.forEach((section) => {
			section.classList.remove('filter-form-visible');
		});
	}
});
const handleProductDetail = async () => {
	const pInnerHeader = document.querySelector('.p-detail-inner-header')
	const pDetailInfo = document.querySelector('.p-detail-info')
	const pInfoWrapper = document.querySelector('.p-info-wrapper')
	const pImage = document.querySelector('.p-image-wrapper .p-image')
	const flagsDefault = document.querySelector('.p-detail .flags-default')
	const flagsExtra = document.querySelector('.p-detail .flags-extra')

	const vip = document.querySelector('.flag-vip')
	if (vip) {
		pImage.appendChild(vip)
	}
	if (flagsDefault && flagsExtra) {
		flagsDefault.appendChild(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}
	// if (flagsDefault) {
	// 	pImage.appendChild(flagsDefault)
	// }
	// if (flagsExtra && !flagsDefault) {
	// 	pImage.appendChild(flagsExtra)
	// }
	const addToCartBtn = pInfoWrapper.querySelector('.add-to-cart-button')
	if (addToCartBtn) {
		addToCartBtn.innerHTML = productDetailAddBtn.find((item) => item.language === shoptetLang)?.text
	}

	// const favoutites = pDetailInfo.querySelector('#dkLabFavouriteDiv .dkLabFavDetailSpan');
	// console.log(favoutites)
	// if (favoutites) {
	// 	const span = favoutites.querySelector('.dkLabFavDetailSpan');
	// 	const text = favoutites.querySelector('span');
	// 	text.innerHTML = productDetailFavourite.find(item => item.language === shoptetLang)?.text;
	// 	if (span.classList.contains('dkLabFavouriteDetailLinkRemove')) {
	// 		text.innerHTML = productDetailFavourite.find(item => item.language === shoptetLang)?.remove;
	// 	}
	// }
	const targetNode = document.body

	if (targetNode) {
		const config = { childList: true, subtree: true }

		const callback = function (mutationsList, observer) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const favourites = document.querySelector('#dkLabFavouriteDiv .dkLabFavDetailSpan')
					if (favourites) {
						// Disconnect the observer before making changes in the DOM
						observer.disconnect()

						const text = favourites.querySelector('span')
						text.innerHTML = productDetailFavourite.find((item) => item.language === shoptetLang)?.text
						if (favourites.classList.contains('dkLabFavouriteDetailLinkRemove')) {
							text.innerHTML = productDetailFavourite.find((item) => item.language === shoptetLang)?.remove
						}

						// Find .social-buttons-wrapper and move #dkLabFavouriteDiv into it
						const socialButtonsWrapper = document.querySelector('.social-buttons-wrapper .link-icons')
						const dkLabFavouriteDiv = document.querySelector('#dkLabFavouriteDiv')
						if (socialButtonsWrapper && dkLabFavouriteDiv) {
							socialButtonsWrapper.appendChild(dkLabFavouriteDiv)
						}

						// Reconnect the observer after making changes in the DOM
						observer.observe(targetNode, config)
					}
				}
			}
		}

		const observer = new MutationObserver(callback)
		observer.observe(targetNode, config)
	}

	if (targetNode) {
		const config = { childList: true, subtree: true };

		const callback = function (mutationsList, observer) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const noteWrapper = document.querySelector('#dkLabNoteMainWrapper');
					const detailParameters = document.querySelector('.detail-parameters');
					const shippingOptions = document.querySelector('.shipping-options');

					if (noteWrapper && detailParameters && shippingOptions) {
						// Odpojit pozorovatele před provedením změn v DOM
						observer.disconnect();

						// Přesunout element #dkLabNoteMainWrapper za .detail-parameters
						detailParameters.insertAdjacentElement('afterend', noteWrapper);

						// Přesunout element .shipping-options za #dkLabNoteMainWrapper
						noteWrapper.insertAdjacentElement('afterend', shippingOptions);

						// Najít .dkLabNoteHeader span uvnitř #dkLabNoteMainWrapper a přepsat jeho text
						const headerSpan = noteWrapper.querySelector('.dkLabNoteHeader span');
						if (headerSpan) {
							headerSpan.textContent = 'Doplňková informace';
						}

						// Najít .dkLabNoteTextArea a přepsat jeho placeholder
						const textArea = noteWrapper.querySelector('.dkLabNoteTextArea');
						if (textArea) {
							textArea.placeholder = 'Zde uveďte požadovaný nápis a/nebo číslici na dort či jiné důležité sdělení (alergie)';
						}

						// Najít .dkLabNoteChooseAttachLabel a přepsat jeho text
						const attachLabel = noteWrapper.querySelector('.dkLabNoteChooseAttachLabel');
						if (attachLabel) {
							attachLabel.textContent = 'Připojit soubor';
						}

						// Pozorovatel zůstane odpojený, aby se zabránilo dalšímu sledování
						break;
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}
	// if (flagsDefault && pImage) pImage.appendChild(flagsDefault)
	if (pInnerHeader && pDetailInfo) pInnerHeader.appendChild(pDetailInfo)
	if (pInfoWrapper && pInnerHeader) pInfoWrapper.prepend(pInnerHeader)

	const pThumbnails = document.querySelector('.p-thumbnails')
	if (pThumbnails) {
		const thumbnailsTrack = pThumbnails.querySelector('.p-thumbnails-inner > div')
		setTimeout(() => {
			if (thumbnailsTrack && pThumbnails.clientWidth < thumbnailsTrack.clientWidth) {
				pThumbnails.classList.add('overflow-next')
			}
		}, 500)
	}

	const customAddToCart = document.createElement('div')
	customAddToCart.classList.add('add-to-cart-wrapper')
	const productPrices = document.querySelector('.p-final-price-wrapper')
	if (productPrices) customAddToCart.appendChild(productPrices)

	console.log("yes");

	const pCode = document.querySelector('.p-info-wrapper .p-code')
	const availability = document.querySelector('.product-top .availability-value')
	const pHeader = document.querySelector('.p-detail-inner-header')
	const pInfo = document.querySelector('.p-info-wrapper')
	if (availability) {
		const label = document.createElement('span');
		label.classList.add('availability-label-first');
		label.innerHTML = availabilityTitle.find(item => item.language === shoptetLang)?.text + ":";
		availability.prepend(label);
		pInfo.appendChild(availability);
	}
	const mark = pHeader.querySelector('.p-detail-info')
	if (mark) {
		const divElement = mark.querySelector('div:not([class])') // select div without a class
		if (divElement) {
			const linkElement = divElement.querySelector('a')
			const textNode = divElement.childNodes[0]

			const spanElement = document.createElement('span')
			spanElement.className = 'brand-label'
			spanElement.textContent = textNode.textContent.trim()

			// Remove the original text node
			divElement.removeChild(textNode)

			// Insert the new span element at the beginning of the div
			divElement.insertBefore(spanElement, divElement.firstChild)
		}
	}

	const saleNumber = document.querySelector('.price-standard')
	const finalNumber = document.querySelector('.price-final .price-final-holder')

	// if (saleNumber && finalNumber) {
	// 	const saleFinal = parseFloat(finalNumber.textContent) - parseFloat(saleNumber.textContent);
	// 	const salePercent = document.querySelector('.price-save .default-variant') || document.querySelector('.price-save');

	// 	const div = document.createElement('div');
	// 	div.classList.add('price-sale');
	// 	const span = document.createElement('span');
	// 	const span1 = document.createElement('span');
	// 	div.appendChild(span);
	// 	div.appendChild(span1);
	// 	span1.classList.add('saved-price-holder');
	// 	span.innerHTML = productDetailSale.find(item => item.language === shoptetLang)?.text;
	// 	// const currencyArray = [
	// 	// 	{ currencyID: 'CZK', currencyText: 'Kč' },
	// 	// 	{ currencyID: 'EUR', currencyText: '€' },
	// 	// 	{ currencyID: 'USD', currencyText: '$' },
	// 	// ];

	// 	// const currency = dataLayer[0].shoptet.currency;
	// 	// const displayCurrency = currencyArray.find(item => item.currencyID === currency)?.currencyText;
	// 	// if (displayCurrency) {

	// 	span1.innerHTML = `${salePercent.textContent}`;
	// 	// }
	// 	pHeader.appendChild(div);
	// }

	// const finalPrice = document.querySelector('.price-final');
	// if (finalPrice) {
	// 	const div = document.createElement('div');
	// 	div.classList.add('final-price');
	// 	const span = document.createElement('span');
	// 	span.classList.add('final-price-label');
	// 	div.appendChild(span);
	// 	div.appendChild(finalPrice);
	// 	span.innerHTML = productDetailPriceText.find(item => item.language === shoptetLang)?.text;
	// 	pHeader.appendChild(div);
	// }

	// const productQuantity = document.querySelector('.add-to-cart .quantity')
	// if (productQuantity) customAddToCart.appendChild(productQuantity)
	const addToCart = document.querySelector('.add-to-cart')
	if (addToCart) customAddToCart.appendChild(addToCart)
	pInfoWrapper.appendChild(customAddToCart)
	const availabilityValue = document.querySelector('.product-top .availability-value')
	const shippingOptions = document.querySelector('.product-top .shipping-options')
	const timeDel = document.querySelector('.delivery-time-label')
	// const th = timeDel.closest('th');
	// th.classList.add('delivery-time-holder')
	// console.log(availabilityValue, shippingOptions)
	// if (th && shippingOptions) th.appendChild(shippingOptions)
	// const priceStandart = document.querySelector('.price-standard');
	// const pricesHolder = customAddToCart.querySelector(".p-final-price-wrapper");
	// if (priceStandart && pricesHolder) pricesHolder.appendChild(priceStandart)
	// konkurenční výhody přesunuté pod tabs
	// const detailUSP = document.querySelector('.benefitBanner')
	// if (detailUSP) {
	// 	const detailContent = document.querySelector('#content')
	// 	const uspContainer = document.createElement('div')
	// 	uspContainer.classList.add('usp-container')
	// 	const uspContainerInner = document.createElement('div')
	// 	uspContainerInner.classList.add('container')
	// 	uspContainerInner.appendChild(detailUSP)
	// 	uspContainer.appendChild(uspContainerInner)
	// 	detailContent.appendChild(uspContainer)
	// }

	// const linkIcon = document.querySelector('.social-buttons-wrapper .link-icon.chat');
	// if (linkIcon) {
	// 	const addToCart = document.querySelector('.product-top .add-to-cart-wrapper');
	// 	linkIcon.innerHTML = askUsText.find(item => item.language === shoptetLang)?.text;
	// 	addToCart.appendChild(linkIcon);
	// };

	if (window.innerWidth <= 767) {
		let wrapRemoved = false

		const handleWrap = () => {
			if (!wrapRemoved) {
				const wrap = document.querySelector('#wrap')
				if (wrap) {
					const link = wrap.querySelector('a')
					if (link) {
						wrap.parentNode.insertBefore(link, wrap)
					}
					wrap.parentNode.removeChild(wrap)
					wrapRemoved = true

					clearInterval(checkInterval)
				}
			}
		}

		const checkInterval = setInterval(handleWrap, 500)

		const thumbnails = document.querySelectorAll('.p-thumbnail')

		// thumbnails na mobilu přetvořené na obrázky vedle sebe se sliderem
		if (thumbnails.length) {
			let mainImage = document.querySelector('.p-image > .p-main-image'),
				productImage = document.querySelector('.product-top .p-image-wrapper'),
				sliderWrapper = document.createElement('div')

			sliderWrapper.classList.add('custom-slider-wrapper')
			sliderWrapper.appendChild(mainImage)

			thumbnails.forEach((thumb, index) => {
				if (index > 0) {
					let imgUrl = thumb.getAttribute('href'),
						aEl = document.createElement('a'),
						imgEl = document.createElement('img')
					aEl.classList.add('p-main-image')
					aEl.href = imgUrl
					aEl.appendChild(imgEl)
					imgEl.src = imgUrl
					sliderWrapper.appendChild(aEl)
				}
			})

			productImage.querySelector('.p-image').appendChild(sliderWrapper)
			console.log(sliderWrapper);

			// $(sliderWrapper).slick({
			// 	infinite: false,
			// 	arrows: false,
			// 	slidesToShow: 1.2,
			// 	slidesToScroll: 1,
			// 	dots: true,
			// })

			// swiperize({
			// 	containers: sliderWrapper,
			// 	slide: '.p-main-image',
			// 	customOptions: {
			// 		fullscreen: false,
			// 		infinity: false,
			// 		dots: true,
			// 		arrows: false,
			// 		scrollbar: false,
			// 		lazyPrevNext: true
			// 	},
			// 	swiperOptions: {
			// 		direction: 'horizontal',
			// 		speed: 800,
			// 		spaceBetween: 12,
			// 		slidesPerView: 1.2,

			// 	},
			// });
		}

		// let flags = document.querySelector('.p-info-wrapper .flags')
		// let imageWrapper = document.querySelector('.p-image-wrapper')
		// if (imageWrapper && flags) {
		// 	imageWrapper.before(flags)
		// }


	}
	const productBanner = document.querySelector('.product-banner-wrapper')
	if (productBanner) {
		const productInfo = document.querySelector('.p-info-wrapper .add-to-cart-wrapper')
		if (productInfo) {
			productInfo.insertAdjacentElement('afterend', productBanner)
		}
	}

	const productStars = document.querySelectorAll('.product-top .star')
	for (const star of productStars) {
		star.removeAttribute('data-toggle')
	}


	const relatedFiles = document.querySelector('#relatedFiles');
	if (relatedFiles) {
		const filesHolder = document.createElement('div');
		filesHolder.className = 'files-holder';

		while (relatedFiles.firstChild) {
			filesHolder.appendChild(relatedFiles.firstChild);
		}

		relatedFiles.appendChild(filesHolder);

		const h3 = document.createElement('h3');
		h3.textContent = 'Ke stažení';
		relatedFiles.insertBefore(h3, filesHolder);
	}


	const socialLinksWrapper = document.querySelector('.social-buttons-wrapper .social-buttons');
    if (socialLinksWrapper) {
        // Vytvoření odkazu .share-link
        const shareLink = document.createElement('a');
        shareLink.classList.add('share-link');
        shareLink.href = '#';
        shareLink.textContent = 'Kopírovat url';

        // Vytvoření span .info-holder
        const infoHolder = document.createElement('span');
        infoHolder.classList.add('info-holder');
        infoHolder.textContent = 'Url produktu zkopírována';

        // Přidání span do odkazu
        shareLink.appendChild(infoHolder);

        // Přidání odkazu na první místo v .social-buttons
        socialLinksWrapper.insertBefore(shareLink, socialLinksWrapper.firstChild);

        // Přidání event listeneru na kliknutí
        shareLink.addEventListener('click', (e) => {
            e.preventDefault();

            // Zkopírování aktuální URL do schránky
            navigator.clipboard.writeText(window.location.href).then(() => {
                // Přidání třídy .active na 4 sekundy
                infoHolder.classList.add('active');
                setTimeout(() => {
                    infoHolder.classList.remove('active');
                }, 4000);
            }).catch(err => {
                console.error('Chyba při kopírování URL: ', err);
            });
        });
    }

}
if (shoptetPage === 'productDetail') {
	handleProductDetail()
}

const handlePage = () => {
	const pageHeader = document.querySelector('.page-header')
	if (pageHeader) {
		document.body.classList.add('has-page-header')
		const contentWrapper = document.querySelector('#content-wrapper')
		contentWrapper.parentElement.insertBefore(pageHeader, contentWrapper)
		const pageHeading = document.querySelector('article > header > h1') || document.querySelector('#content > div > h1')
		const pageHeadingPlaceholder = pageHeader.querySelector('.h1-placeholder')
		if (pageHeading && pageHeadingPlaceholder) {
			pageHeadingPlaceholder.innerHTML = ''
			pageHeadingPlaceholder.appendChild(pageHeading)
			if (document.body.classList.contains('type-posts-listing')) pageHeading.classList.add('homepage-group-title', 'text-center')
		}
	}
}
if (document.body.classList.contains('type-page') || document.body.classList.contains('type-posts-listing')) {
	handlePage()
	document.addEventListener('ShoptetDOMPageContentLoaded', handlePage)
}

const handlePost = async () => {
	const postHeaderWrapper = document.createElement('div')
	postHeaderWrapper.classList.add('post-header-wrapper')
	const postHeader = document.createElement('div')
	postHeader.classList.add('columns', 'col-2', 'align-center', 'container')
	postHeaderWrapper.appendChild(postHeader)
	const postHeaderTexts = document.createElement('div')
	postHeaderTexts.classList.add('post-header-texts', 'column')
	const postHeaderImage = document.createElement('div')
	postHeaderImage.classList.add('post-header-image', 'column')
	postHeader.appendChild(postHeaderTexts)
	postHeader.appendChild(postHeaderImage)
	const postDate = document.querySelector('.news-item-detail meta[itemprop="datePublished"]')
	if (postDate) {
		const postDateEl = document.createElement('div')
		postDateEl.classList.add('post-date')
		postDateEl.innerHTML = new Date(postDate.getAttribute('content')).toLocaleString('cs-CZ', {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		})
		postHeaderTexts.appendChild(postDateEl)
	}
	const postTitle = document.querySelector('.news-item-detail h1[itemprop="headline"]')
	if (postTitle) postHeaderTexts.appendChild(postTitle)
	const postDescriptionContent = document.querySelector('.news-item-detail meta[itemprop="description"]')
	if (postDescriptionContent) {
		const postDescription = document.createElement('p')
		postDescription.classList.add('post-description')
		postDescription.innerHTML = postDescriptionContent.getAttribute('content')
		postHeaderTexts.appendChild(postDescription)
	}
	const contentWrapper = document.querySelector('#content-wrapper')
	contentWrapper.parentElement.insertBefore(postHeaderWrapper, contentWrapper)

	const postImageURL = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="url"]')
	const postImageWidth = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="width"]')
	const postImageHeight = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="height"]')
	if (postImageURL) {
		const postImage = document.createElement('img')
		postImage.src = postImageURL.getAttribute('content')
		postImage.width = postImageWidth.getAttribute('content')
		postImage.height = postImageHeight.getAttribute('content')
		postHeaderImage.appendChild(postImage)
	}
	// else {
	// 	const urlArray = []
	// 	urlArray.push(window.location.pathname.replaceAll('/blog/', '').replaceAll('/archiv/', '').replaceAll('/', ''))
	// 	const imageData = await fetchBlogImages(urlArray)
	// 	if (imageData) {
	// 		imageData.forEach((img) => {
	// 			if (window.location.pathname.includes(img.url)) {
	// 				const postImage = document.createElement('img')
	// 				postImage.src = img.image
	// 				postHeaderImage.appendChild(postImage)
	// 			}
	// 		})
	// 	}
	// }

	// vytvoří sidebar v blogu a fetchne tam podrubriky
	const postSidebar = document.createElement('div')
	postSidebar.classList.add('type-posts-listing', 'blog-title-holder')
	const postContent = document.querySelector('#content')
	const header = document.querySelector('.post-header-wrapper')

	// const blogTitle2 = document.createElement('h4');
	// postSidebar.appendChild(blogTitle2);
	// const blogNadpis = blogTitle.find(item => item.language === shoptetLang);
	// if (blogNadpis) {
	// 	blogTitle2.innerHTML = blogNadpis.text;
	// }

	// if (header) {
	// 	header.insertAdjacentElement('beforebegin', postSidebar);
	// }
}
if (document.body.classList.contains('type-post')) handlePost()

function getScrollbarWidth() {
	const div = document.createElement('div')
	div.style.overflowY = 'scroll'
	div.style.width = '50px'
	div.style.height = '50px'
	div.style.visibility = 'hidden'
	document.body.appendChild(div)
	const scrollbarWidth = div.offsetWidth - div.clientWidth
	document.body.removeChild(div)
	return scrollbarWidth
}

document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`)

// const addCartTitle = () => {
// 	const cartWrapper = document.querySelector("#cart-wrapper");
// 	if (cartWrapper) {
// 		const cartTable = cartWrapper.querySelector(".col-md-8 .cart-content .cart-table tbody");
// 		if (cartTable) {
// 			if (!cartTable.parentNode.querySelector('h2')) {
// 				const cartTitle = document.createElement("h2");
// 				const cartTitleText = cartTitleTexts.find(item => item.language === shoptetLang);
// 				if (cartTitleText) {
// 					cartTitle.innerHTML = cartTitleText.text;
// 				}
// 				cartTable.parentNode.insertBefore(cartTitle, cartTable);
// 			}
// 		}
// 	}
// };

// addCartTitle();
// document.addEventListener('ShoptetDOMCartContentLoaded', addCartTitle);
// document.addEventListener('ShoptetDOMContentLoaded', addCartTitle);
// document.addEventListener('ShoptetDOMCartCountUpdated', addCartTitle);
// document.addEventListener('ShoptetCartUpdated', addCartTitle);

const allProducts = document.querySelectorAll('.product')
if (allProducts.length) {
	allProducts.forEach((product) => {
		const productWidgets = product.querySelectorAll('.widget-parameter-wrapper .widget-parameter-list .widget-parameter-value')

		if (productWidgets.length > 0) {
			productWidgets.forEach((widget, index) => {
				if (index >= 3) {
					widget.style.display = 'none'
				}
			})
		}
	})
}
const footer = document.querySelector('#footer .custom-footer')
// if (footer) {
// 	const oldSiteName = document.querySelector('#footer .site-name')
// 	const elements7BannerWrapper = footer.querySelector('.custom-footer .custom-footer__banner9 .banner-wrapper')

// 	// If the old site name exists, remove it
// 	// if (oldSiteName) {
// 	// 	oldSiteName.remove()
// 	// }

// 	// If elements7BannerWrapper exists, create and insert the new site name element before it
// 	if (elements7BannerWrapper) {
// 		const newSiteNameHTML = `<div class="site-name"><a href="/" data-testid="linkWebsiteLogo"><img src="/user/documents/upload/logo-white.svg" alt="SPECTRUM CZ s.r.o."></a></div>`
// 		// Convert the HTML string into a document fragment
// 		const range = document.createRange()
// 		const documentFragment = range.createContextualFragment(newSiteNameHTML)
// 		elements7BannerWrapper.parentNode.insertBefore(documentFragment, elements7BannerWrapper)
// 	}
// }

const sliderWrapper = document.querySelector('.slider-wrapper')
if (sliderWrapper) {
	const content = sliderWrapper.querySelector('.slider-content')
	const header = sliderWrapper.querySelector('.slider-header .from')
	header.insertAdjacentElement('afterend', content)
}
function rearrangeSliderContent() {
	const sliderWrapper = document.querySelector('.slider-wrapper')
	if (sliderWrapper) {
		const content = sliderWrapper.querySelector('.slider-content')
		const header = sliderWrapper.querySelector('.slider-header .from')
		if (header && content) {
			header.insertAdjacentElement('afterend', content)
		}
	}
}
rearrangeSliderContent()
document.addEventListener('ShoptetDOMPageContentLoaded', rearrangeSliderContent)
document.addEventListener('ShoptetDOMContentLoaded', rearrangeSliderContent)

if (shoptetPage === 'productDetail') {
	// let velikost = document.querySelectorAll('.variant-list th')
	// if (velikost.length) {
	// 	velikost.forEach((item) => {
	// 		if (tabulkaVelikostiUmisteni.some(phrase => item.innerText.includes(phrase))) {
	// 			let link = document.createElement('a');
	// 			const matchingLangObject = tabulkaVelikostiTextOdkaz.find(obj => obj.language === shoptetLang);
	// 			if (matchingLangObject) {
	// 				link.href = matchingLangObject.url;
	// 				link.textContent = matchingLangObject.text;
	// 				link.classList.add('size-table-link');
	// 				item.append(link);
	// 				item.classList.add('size-table-link-wrapper');
	// 			}
	// 		}
	// 	});
	// }
	// const pDetail = document.querySelector(".p-detail");
	// const innerD = pDetail.querySelector(".p-detail-inner");
	// const form = innerD.querySelector("form");
	// const pCode = form.querySelector('.p-code');
	// const socialBan = form.querySelector(".social-buttons-wrapper");
	// const wrapper = document.createElement('div');
	// wrapper.classList.add('wrapper');
	// socialBan.insertBefore(wrapper, socialBan.firstChild);
	// if (pCode) {
	// 	wrapper.appendChild(pCode);
	// }
	// const metaWarranty = document.querySelector('meta[itemprop="warranty"]');
	// if (metaWarranty) {
	// 	warrantyContent = metaWarranty.getAttribute('content');
	// 	const zaruka = document.createElement('div');
	// 	zaruka.classList.add('zaruka');
	// 	const zaruka1 = document.createElement('span');
	// 	zaruka1.classList.add('zaruka1');
	// 	const zaruka2 = document.createElement('span');
	// 	zaruka2.classList.add('zaruka2');
	// 	wrapper.appendChild(zaruka);
	// 	zaruka.appendChild(zaruka1);
	// 	zaruka.appendChild(zaruka2);
	// 	const zarukaNadpis = zarukaNadpisy.find(item => item.language === shoptetLang);
	// 	if (zarukaNadpis) {
	// 		zaruka1.innerHTML = zarukaNadpis.text;
	// 	}
	// 	zaruka2.innerHTML = warrantyContent;
	// }
}

// if (shoptetPage === "productDetail") {
// 	if (window.innerWidth < 767) {
// 		let basicDescription = document.querySelector('#description .basic-description');

// 		if (basicDescription) {
// 			let h3Elements = Array.from(basicDescription.querySelectorAll('h3'));
// 			let wrapper = null;

// 			h3Elements.forEach((h3, index) => {
// 				h3.classList.add('content-activator');

// 				if (index === 0) {
// 					h3.classList.add('active'); // Add 'active' class to the first .content-activator
// 				}

// 				if (index === 0 || h3Elements[index - 1].nextElementSibling !== h3) {
// 					wrapper = document.createElement('div');
// 					wrapper.className = 'wrapper';
// 					basicDescription.insertBefore(wrapper, h3);
// 				}

// 				let element = h3;
// 				while (element && element !== h3Elements[index + 1]) {
// 					let nextElement = element.nextElementSibling;
// 					wrapper.appendChild(element);
// 					element = nextElement;
// 				}

// 				let h3Element = wrapper.querySelector('h3');
// 				let contentHolder = document.createElement('div');
// 				contentHolder.className = 'content-holder';

// 				if (index === 0) {
// 					contentHolder.classList.add('active', 'op-1'); // Add 'active' and 'op-1' classes to the first .content-holder
// 				}

// 				Array.from(wrapper.childNodes).forEach((node) => {
// 					if (node !== h3Element) {
// 						contentHolder.appendChild(node);
// 					}
// 				});

// 				wrapper.appendChild(contentHolder);
// 			});
// 		}

// 		const description = document.querySelector('#description');
// 		if (description) {
// 			const pInfo = document.querySelector('.product-top .p-info-wrapper');
// 			if (pInfo && description) {
// 				pInfo.appendChild(description);
// 			}
// 		}

// 		document.querySelectorAll('.content-activator').forEach((activator) => {
// 			activator.addEventListener('click', function () {
// 				let wrapper = this.closest('.wrapper');
// 				if (wrapper) {
// 					let contentHolder = wrapper.querySelector('.content-holder');
// 					if (contentHolder) {
// 						if (this.classList.contains('active')) {
// 							contentHolder.classList.remove('op-1');
// 							setTimeout(() => {
// 								contentHolder.classList.remove('active');
// 								this.classList.remove('active');
// 							}, 300);
// 						} else {
// 							this.classList.add('active');
// 							contentHolder.classList.add('active');
// 							setTimeout(() => {
// 								contentHolder.classList.add('op-1');
// 							}, 300);
// 						}
// 					}
// 				}
// 			});
// 		});
// 		let activator = document.querySelector('.extended-description h3');
// 		if (activator) {
// 			activator.addEventListener('click', function () {
// 				let wrapper = this.closest('.extended-description');
// 				if (wrapper) {
// 					let contentHolder = wrapper.querySelector('.detail-parameters');
// 					if (contentHolder) {
// 						if (this.classList.contains('active')) {
// 							contentHolder.classList.remove('op-1');
// 							setTimeout(() => {
// 								contentHolder.classList.remove('active');
// 								this.classList.remove('active');
// 							}, 300);
// 						} else {
// 							this.classList.add('active');
// 							contentHolder.classList.add('active');
// 							setTimeout(() => {
// 								contentHolder.classList.add('op-1');
// 							}, 300);
// 						}
// 					}
// 				}
// 			});
// 		}
// 	}


// }

// if (shoptetPage === "section") {
// 	const subcategories = document.querySelector('.subcategories');
// 	if (subcategories) {
// 		// const moveSub = () => {
// 		const contentInner = document.querySelector('.content-inner');
// 		const h1 = document.querySelector('.content-inner h1');
// 		const sub = document.querySelector('.subcategories');
// 		if (contentInner && h1) {
// 			let contentHolder = document.createElement('div');
// 			contentHolder.className = 'blog-title-holder';
// 			contentHolder.appendChild(h1);
// 			contentHolder.appendChild(sub);
// 			contentInner.insertBefore(contentHolder, contentInner.firstChild);
// 		}
// 		// }
// 		// moveSub();
// 	}
// }
if (shoptetPage === 'category') {
	// function moveSubcategories() {
	// 	const subcategoriesHelp = document.querySelector('.subcategories.with-image');
	// 	if (subcategoriesHelp) {
	// 		const topHelper = document.querySelector('.category-top-wrapper');
	// 		topHelper.appendChild(subcategoriesHelp);
	// 	}
	// }
	// moveSubcategories();
	// document.addEventListener('ShoptetDOMPageContentLoaded', moveSubcategories);
	// document.addEventListener('ShoptetDOMContentLoaded', moveSubcategories);
}

// if (shoptetPage === "productDetail") {
// 	function variantsHandler(id) {
// 		$(function () {
// 			if ($(`.variant-list select.parameter-id-${id}`).length) {
// 				$(`.variant-list select.parameter-id-${id}`).each(function (
// 					option_index
// 				) {
// 					so_classes = $(this).attr("class");
// 					so_value = $(this).html();
// 					so_attr1 = $(this).attr("data-parameter-id");
// 					so_attr2 = $(this).attr("data-parameter-name");
// 					so_attr3 = $(this).attr("id");
// 					so_attr4 = $(this).attr("name");
// 					so_newLabel = $("<div></div>").html(so_value);
// 					$(so_newLabel).attr("class", so_classes);
// 					$(so_newLabel).attr("data-parameter-id", so_attr1);
// 					$(so_newLabel).attr("data-parameter-name", so_attr2);
// 					$(so_newLabel).attr("id", so_attr3);
// 					$(so_newLabel).attr("name", so_attr4);
// 					$(so_newLabel).attr("value", option_index);

// 					$(this).replaceWith(so_newLabel);
// 				});
// 				if (
// 					$(`.variant-list:first-of-type .parameter-id-${id} option`).length == 1
// 				) {
// 					$(`.variant-list:first-of-type .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				if (
// 					$(`.variant-list:nth-of-type(2) .parameter-id-${id} option`).length ==
// 					1
// 				) {
// 					$(`.variant-list:nth-of-type(2) .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				if (
// 					$(`.variant-list:nth-of-type(3) .parameter-id-${id} option`).length ==
// 					1
// 				) {
// 					$(`.variant-list:nth-of-type(3) .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				$(`.variant-list .parameter-id-${id} option:first-of-type`).wrap(
// 					"<span></span>"
// 				);
// 				$(
// 					`.variant-list:first-of-type .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(
// 					`.variant-list:nth-of-type(2) .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(
// 					`.variant-list:nth-of-type(3) .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(`.variant-list .parameter-id-${id} option:not(:first-child)`).wrap(
// 					"<label class='advanced-parameter'></label>"
// 				);
// 				$(`.variant-list .parameter-id-${id} label option`).each(function (
// 					data_index
// 				) {
// 					option_value = $(this).attr("value");
// 					option_html = $(this).html();
// 					option_select = $(this).attr("selected");
// 					option_name = $(this).parents(`.parameter-id-${id}`).attr("name");
// 					option_newLabel = $("<input>");
// 					option_newInDiv = $("<span class='parameter-value'></span>").html(
// 						option_html
// 					);
// 					option_newBeDiv = $(
// 						'<span class="advanced-parameter-inner show-tooltip" title=""></span>'
// 					);
// 					option_newApSpan = $('<span class="pkVS"></span>').html(option_html);
// 					option_data_index = data_index + 1;
// 					$(option_newLabel).attr("value", option_value);
// 					$(option_newLabel).attr("name", option_name);
// 					$(option_newLabel).attr("selected", option_select);
// 					$(option_newLabel).attr("data-index", option_data_index);
// 					$(option_newLabel).attr("type", "radio");

// 					$(this)
// 						.parents(".hidden-split-parameter")
// 						.children("span")
// 						.children("input")
// 						.attr("name", option_name);
// 					$(this).after(option_newInDiv);
// 					$(this).before(option_newBeDiv);
// 					$(this)
// 						.parent("label")
// 						.find(".advanced-parameter-inner")
// 						.append(option_newApSpan);
// 					$(this).replaceWith(option_newLabel);

// 					let dataCodeHelper = `${so_attr1}-${option_value}`;

// 					const c = $(document).find(".p-code .parameter-dependent");
// 					const helpingData = dataLayer[0].shoptet.product.codes;

// 					// console.log(helpingData);

// 					c.each(function () {
// 						if ($(this).hasClass(dataCodeHelper)) {
// 							const innerText = $(this).html().replace(/\s/g, '');
// 							$(option_newLabel).attr("data-code-helper", innerText);
// 							const label = option_newLabel.closest(".advanced-parameter");
// 							// Projdi všechny objekty v poli helpingData

// 							helpingData.forEach(item => {

// 								if (item.code === innerText) {

// 									const quantity = item.quantity;

// 									if (quantity < 1) {
// 										// console.log("data-code-helper: " + innerText + ", quantity: " + quantity);
// 										label.addClass("dissable");
// 										// label.style.opacity = "0,5";
// 									}
// 								}
// 							});
// 						}
// 					});
// 				});
// 			}
// 		});
// 	}
// 	let detailParametersVariants = document.querySelectorAll(
// 		".detail-parameters td > select"
// 	);
// 	if (detailParametersVariants.length) {
// 		detailParametersVariants.forEach((variant) => {
// 			if (variant.hasAttribute("data-parameter-id")) {
// 				let variantId = variant.getAttribute("data-parameter-id");
// 				if (variantId) {
// 					variantsHandler(variantId);
// 				}
// 			}
// 		});
// 	}
// }

// if (shoptetPage === 'homepage') {
// 	if (window.innerWidth > 767) {
// 		const updateControlsPosition = () => {
// 			const container = document.querySelector('.container')
// 			const marginLeftValue = window.getComputedStyle(container).marginLeft
// 			const newLeftValue = parseInt(marginLeftValue) + 32 + 'px'
// 			const carouselControlRight = document.querySelector('.carousel-control.right')
// 			if (carouselControlRight) carouselControlRight.style.left = marginLeftValue;
// 			const carouselControlLeft = document.querySelector('.carousel-control.left')
// 			if (carouselControlLeft) carouselControlLeft.style.right = marginLeftValue;

// 			// Update for each .extended-banner-texts inside #carousel .carousel-inner .item
// 			// const extendedBannerTexts = document.querySelectorAll('#carousel .carousel-inner .item .extended-banner-texts')
// 			// extendedBannerTexts.forEach((text) => {
// 			// 	text.style.left = newLeftValue
// 			// })
// 		}

// 		updateControlsPosition()
// 		window.addEventListener(\'resize', updateControlsPosition)
// 		document.addEventListener('ShoptetDOMContentLoaded', updateControlsPosition)
// 	}
// }


function insertNewsletter() {
	const newsletter = document.querySelector('.custom-footer__newsletter');
	const target = document.querySelector('.side-img.third .flex-holder .right');

	if (newsletter && target) {
		target.appendChild(newsletter);
	}
}

insertNewsletter();
document.addEventListener('ShoptetDOMPageContentLoaded', insertNewsletter);
document.addEventListener('ShoptetDOMContentLoaded', insertNewsletter);